import { CSSProperties } from 'react';
import './icon.scss';
export interface SVGProps {
  context?:
    | 'default'
    | 'white'
    | 'info'
    | 'warning'
    | 'error'
    | 'success'
    | 'red'
    | 'yellow'
    | 'green';
  size?: number;
  style?: CSSProperties;
}

const Bag = ({ context = 'default', size = 16, ...props }: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M14.1204 4.99C14.0604 4.43 13.5404 4 12.9204 4H11.5004V3.5C11.5004 1.57 9.93036 0 8.00036 0C6.07036 0 4.50036 1.57 4.50036 3.5V4H3.08036C2.46036 4 1.94036 4.43 1.88036 4.99L1.01036 13.62C0.88036 14.9 1.99036 16 3.41036 16H12.5904C14.0104 16 15.1204 14.9 14.9904 13.62L14.1204 4.99ZM5.50036 3.5C5.50036 2.12 6.62036 1 8.00036 1C9.38036 1 10.5004 2.12 10.5004 3.5V4H5.50036V3.5ZM13.6004 14.43C13.3604 14.7 12.9904 14.85 12.5904 14.85H3.41036C3.01036 14.85 2.64036 14.7 2.40036 14.43C2.27036 14.29 2.12036 14.05 2.16036 13.73L3.02036 5.15C3.02036 5.15 3.06036 5.14 3.08036 5.14H4.50036V7.49C4.50036 7.77 4.72036 7.99 5.00036 7.99C5.28036 7.99 5.50036 7.77 5.50036 7.49V5.14H10.5004V7.49C10.5004 7.77 10.7204 7.99 11.0004 7.99C11.2804 7.99 11.5004 7.77 11.5004 7.49V5.14H12.9204C12.9204 5.14 12.9704 5.14 12.9804 5.15L13.8404 13.73C13.8704 14.05 13.7204 14.28 13.6004 14.43Z' />
  </svg>
);

const Billing = ({ context = 'default', size = 16, ...props }: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.625 2.75C1.625 2.54289 1.79289 2.375 2 2.375H4H12H14C14.2071 2.375 14.375 2.54289 14.375 2.75C14.375 2.95711 14.2071 3.125 14 3.125H12.375V12.85C12.375 13.3238 11.8341 13.5943 11.455 13.31L10 12.2188L8.345 13.46C8.14056 13.6133 7.85944 13.6133 7.655 13.46L6 12.2188L4.545 13.31C4.16594 13.5943 3.625 13.3238 3.625 12.85V3.125H2C1.79289 3.125 1.625 2.95711 1.625 2.75ZM4.375 12.5V3.125H11.625V12.5L10.345 11.54C10.1406 11.3867 9.85944 11.3867 9.655 11.54L8 12.7812L6.345 11.54C6.14056 11.3867 5.85944 11.3867 5.655 11.54L4.375 12.5ZM6 4.375C5.79289 4.375 5.625 4.54289 5.625 4.75C5.625 4.95711 5.79289 5.125 6 5.125H10C10.2071 5.125 10.375 4.95711 10.375 4.75C10.375 4.54289 10.2071 4.375 10 4.375H6ZM5.625 6.75C5.625 6.54289 5.79289 6.375 6 6.375H10C10.2071 6.375 10.375 6.54289 10.375 6.75C10.375 6.95711 10.2071 7.125 10 7.125H6C5.79289 7.125 5.625 6.95711 5.625 6.75ZM6 8.375C5.79289 8.375 5.625 8.54289 5.625 8.75C5.625 8.95711 5.79289 9.125 6 9.125H10C10.2071 9.125 10.375 8.95711 10.375 8.75C10.375 8.54289 10.2071 8.375 10 8.375H6Z'
    />
  </svg>
);

export const Calendar = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 256 256'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M208 34h-26V24a6 6 0 0 0-12 0v10H86V24a6 6 0 0 0-12 0v10H48a14 14 0 0 0-14 14v160a14 14 0 0 0 14 14h160a14 14 0 0 0 14-14V48a14 14 0 0 0-14-14ZM48 46h26v10a6 6 0 0 0 12 0V46h84v10a6 6 0 0 0 12 0V46h26a2 2 0 0 1 2 2v34H46V48a2 2 0 0 1 2-2Zm160 164H48a2 2 0 0 1-2-2V94h164v114a2 2 0 0 1-2 2Z' />
  </svg>
);

const CardDetails = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 48 48'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke'
      xmlns='http://www.w3.org/2000/svg'
      id='vector'
      d='M26.8 40H18.8C16.0697 40 14.7046 40 13.6618 39.4768C12.7445 39.0166 11.9987 38.2823 11.5313 37.3792C11 36.3524 11 35.0083 11 32.32V15.68C11 12.9917 11 11.6476 11.5313 10.6208C11.9987 9.71767 12.7445 8.98336 13.6618 8.52317C14.7046 8 16.0697 8 18.8 8H29.2C31.9303 8 33.2954 8 34.3382 8.52317C35.2555 8.98336 36.0013 9.71767 36.4687 10.6208C37 11.6476 37 12.9917 37 15.68V27.52M27.25 22.4H17.5M20.75 28.8H17.5M30.5 16H17.5'
      fill='none'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      className='_stroke'
      xmlns='http://www.w3.org/2000/svg'
      id='vector_2'
      d='M32.3999 42L37.2909 37.2M37.2909 37.2L41.9999 32.5786M37.2909 37.2L41.9999 41.8215M37.2909 37.2L32.3999 32.4'
      fill='none'
      stroke='#EBB349'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const ChevronLeft = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M11.25 14.5L4.75 8L11.25 1.5'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const ChevronRight = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M4.75 14.5L11.25 8L4.75 1.5'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const ChevronDown = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='icon__nofill'
      d='M3.5 6.75L10 13.25L16.5 6.75'
      stroke='#181818'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
  </svg>
);

const ChevronRightLight = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 10 18'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='icon__nofill'
      d='M1 17L9 9L1 0.999999'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const ClockInStockProcess = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 48 48'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke'
      d='M24 39C32.2843 39 39 32.2843 39 24C39 15.7157 32.2843 9 24 9C15.7157 9 9 15.7157 9 24C9 32.2843 15.7157 39 24 39Z'
      stroke='#181818'
      strokeMiterlimit='10'
      fillOpacity='0'
    />
    <path d='M36.0891 25.0831C36.6881 25.0831 37.1736 24.5975 37.1736 23.9986C37.1736 23.3996 36.6881 22.9141 36.0891 22.9141C35.4902 22.9141 35.0046 23.3996 35.0046 23.9986C35.0046 24.5975 35.4902 25.0831 36.0891 25.0831Z' />
    <path d='M11.9815 25.0831C12.5804 25.0831 13.066 24.5975 13.066 23.9986C13.066 23.3996 12.5804 22.9141 11.9815 22.9141C11.3825 22.9141 10.897 23.3996 10.897 23.9986C10.897 24.5975 11.3825 25.0831 11.9815 25.0831Z' />
    <path d='M24.0811 13.1426C24.68 13.1426 25.1656 12.6571 25.1656 12.0581C25.1656 11.4592 24.68 10.9736 24.0811 10.9736C23.4821 10.9736 22.9966 11.4592 22.9966 12.0581C22.9966 12.6571 23.4821 13.1426 24.0811 13.1426Z' />
    <path d='M24.0811 37.5362C24.68 37.5362 25.1656 37.0506 25.1656 36.4517C25.1656 35.8527 24.68 35.3672 24.0811 35.3672C23.4821 35.3672 22.9966 35.8527 22.9966 36.4517C22.9966 37.0506 23.4821 37.5362 24.0811 37.5362Z' />
    <path
      className='_stroke'
      d='M24 17.5312V23.5548C24 23.8422 24.1045 24.1035 24.3136 24.3126L30.3632 30.4668'
      stroke='#181818'
      strokeMiterlimit='10'
      strokeLinecap='round'
      fillOpacity='0'
    />
  </svg>
);

const CreditCard = ({ context = 'default', size = 16, ...props }: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M14 0H2C0.9 0 0 0.9 0 2V10C0 11.1 0.9 12 2 12H14C15.1 12 16 11.1 16 10V2C16 0.9 15.1 0 14 0ZM2 1H14C14.55 1 15 1.45 15 2H1C1 1.45 1.45 1 2 1ZM15 10C15 10.55 14.55 11 14 11H2C1.45 11 1 10.55 1 10V5H15V10ZM1 4V3H15V4H1Z' />
  </svg>
);

const DownloadLink = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 21.5 21.5'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g>
      <g transform='translate(-200.000000, -693.000000)'>
        <g transform='translate(20.000000, 150.000000)'>
          <g transform='translate(180.000000, 543.000000)'>
            <g transform='translate(0.749700, 0.749900)'>
              <g>
                <path d='M16.2,20.7H3.7c-2.5,0-4.5-2-4.5-4.5v-3.7c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v3.7c0,1.6,1.3,3,3,3 h12.5c1.6,0,3-1.3,3-3v-3.7c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v3.7C20.7,18.7,18.7,20.7,16.2,20.7z' />
              </g>
              <g>
                <path d='M10,14.9c-0.4,0-0.8-0.3-0.8-0.8V0c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v14.1 C10.7,14.5,10.4,14.9,10,14.9z' />
              </g>
              <g>
                <path d='M10,14.9c-0.2,0-0.4-0.1-0.5-0.2L3.9,9.1C3.6,8.8,3.6,8.3,3.9,8s0.8-0.3,1.1,0l5.1,5.1L15,8 c0.3-0.3,0.8-0.3,1.1,0c0.3,0.3,0.3,0.8,0,1.1l-5.6,5.6C10.4,14.8,10.2,14.9,10,14.9z' />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const Edit = ({ context = 'default', size = 16, ...props }: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 20 20'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M19.2678 1.60629L18.3937 0.732109C17.923 0.263292 17.2856 1.19501e-05 16.6212 1.19501e-05C15.9568 1.19501e-05 15.3196 0.263277 14.8487 0.732109L1.83925 13.7417C1.82878 13.7524 1.81909 13.7639 1.80941 13.7747C1.80565 13.7795 1.8013 13.7836 1.79735 13.7882C1.78115 13.8083 1.76613 13.8295 1.75229 13.8512C1.74953 13.8556 1.74696 13.8603 1.74419 13.8651C1.73352 13.8817 1.72364 13.899 1.71474 13.9166C1.71158 13.9232 1.70822 13.9301 1.70526 13.9374H1.70545C1.69735 13.9552 1.69024 13.9732 1.68391 13.9915C1.68391 13.9959 1.68016 14 1.67858 14.0048L0.0313081 19.1465C-0.0435954 19.3797 0.0182645 19.6353 0.191588 19.8084C0.364713 19.9817 0.62025 20.0436 0.85345 19.9687L5.99475 18.3213C5.9989 18.3213 6.00225 18.3181 6.00641 18.3165C6.02558 18.3102 6.04455 18.3027 6.06293 18.2942L6.08289 18.2853C6.10127 18.276 6.11965 18.2655 6.13763 18.2539C6.14198 18.2513 6.14613 18.2491 6.15028 18.2464C6.17221 18.2327 6.19316 18.2175 6.21313 18.2013C6.21787 18.1976 6.22162 18.1934 6.22597 18.1896C6.23724 18.18 6.2487 18.1701 6.25957 18.1582L19.268 5.15169C19.7367 4.6807 20 4.0435 20 3.379C20 2.7145 19.7366 2.0771 19.2678 1.60629ZM5.7955 16.7744L3.22708 14.2057L13.8819 3.54994L16.4503 6.11858L5.7955 16.7744ZM1.66445 18.335L2.59688 15.425L4.57417 17.4025L1.66445 18.335ZM18.3419 4.22694L17.3751 5.19381L14.8067 2.62497L15.7733 1.6581C15.9987 1.43475 16.3035 1.30925 16.6209 1.30925C16.9385 1.30925 17.243 1.43476 17.4685 1.6581L18.3419 2.53151C18.5652 2.75703 18.6907 3.06163 18.6907 3.37923C18.6907 3.69665 18.5652 4.00143 18.3419 4.22694Z' />
  </svg>
);

const EyePasswordSlash = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 25 25'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.5062 1.17663C19.7141 0.78678 19.5667 0.302195 19.1768 0.0942755C18.787 -0.113643 18.3024 0.0338393 18.0945 0.423687L15.949 4.44648C14.8352 4.15395 13.6787 4.00063 12.5014 4H12.5007V4.00055C7.35924 4.00076 2.61479 6.91408 0.0943203 11.6173H0.0945254C-0.03144 11.8521 -0.03144 12.1389 0.0941151 12.3738C1.86125 15.6773 4.72508 18.0989 8.05365 19.2502L6.09446 22.9237C5.88654 23.3135 6.03402 23.7981 6.42387 24.006C6.81372 24.214 7.2983 24.0665 7.50622 23.6766L19.5062 1.17663ZM8.78677 17.8756L9.89709 15.7937C8.77507 14.9422 8.04202 13.5573 8.04202 12.0003C8.04202 9.4253 10.0466 7.32124 12.4999 7.32124C13.1094 7.32124 13.6911 7.45111 14.2213 7.6858L15.2015 5.84799C14.3242 5.64837 13.4196 5.54444 12.5005 5.54408H12.5C8.02683 5.54408 3.89425 7.9994 1.58623 11.9961C3.23409 14.8546 5.81495 16.9256 8.78677 17.8756ZM13.4981 9.04188C13.1864 8.92711 12.8505 8.86477 12.4999 8.86477C10.8414 8.86477 9.51281 10.2593 9.51281 12.0001C9.51281 12.99 9.9426 13.8681 10.6184 14.4412L13.4981 9.04188ZM16.1568 9.33146L15.3081 10.9228C15.4238 11.2583 15.4868 11.621 15.4868 12.0001C15.4868 13.5269 14.4645 14.7874 13.0941 15.074L12.2422 16.6714C12.3275 16.6765 12.4134 16.6791 12.4999 16.6791C14.953 16.6791 16.9576 14.5751 16.9576 12.0003C16.9576 11.0101 16.6612 10.0895 16.1568 9.33146ZM12.5011 18.4563C12.1047 18.4561 11.711 18.4367 11.321 18.3987L10.543 19.8574C11.1863 19.9514 11.8402 19.9997 12.5005 20V19.9998H12.5014C17.6429 19.9978 22.3868 17.0828 24.9057 12.378C25.0314 12.1433 25.0314 11.8565 24.9057 11.6218C23.3837 8.77909 21.0493 6.59007 18.3058 5.30199L17.5846 6.6543C19.9733 7.74444 22.0241 9.59292 23.4127 12.0005C21.1061 15.9984 16.9742 18.4541 12.5011 18.4563Z'
    />
  </svg>
);

const EyePasswordOpen = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 25 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.5007 0.000546754C7.35924 0.000762132 2.61479 2.91408 0.0943203 7.61734H0.0945254C-0.03144 7.85205 -0.03144 8.13888 0.0941151 8.37384C2.61222 13.0811 7.35719 15.9978 12.5005 16V15.9998H12.5014C17.6429 15.9978 22.3868 13.0828 24.9057 8.37803C25.0314 8.14331 25.0314 7.85649 24.9057 7.62175C22.3867 2.91706 17.6426 0.00275631 12.5014 0H12.5007V0.000546754ZM12.5005 1.54408C16.9742 1.5458 21.1066 4.00216 23.4127 8.00047C21.1061 11.9984 16.9742 14.4541 12.5011 14.4563C8.02594 14.4546 3.89241 11.9965 1.58623 7.99606C3.89425 3.9994 8.02683 1.54408 12.5 1.54408H12.5005ZM12.4999 3.32124C10.0466 3.32124 8.04202 5.4253 8.04202 8.0003C8.04202 10.5751 10.0466 12.6791 12.4999 12.6791C14.953 12.6791 16.9576 10.5751 16.9576 8.0003C16.9576 5.4253 14.953 3.32124 12.4999 3.32124ZM12.4999 4.86478C14.1582 4.86478 15.4868 6.2593 15.4868 8.00008C15.4868 9.74064 14.1582 11.1352 12.4999 11.1352C10.8414 11.1352 9.51281 9.74064 9.51281 8.00008C9.51281 6.2593 10.8414 4.86478 12.4999 4.86478Z'
    />
  </svg>
);

export const Gift = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_1_11430)'>
      <path
        d='M5.19741 1.67342L7.14889 3.6249H4.37995C3.65439 3.6249 3.16985 2.88049 3.44889 2.21943L3.54873 1.98981L3.54874 1.98981L3.54904 1.9891C3.8277 1.32959 4.68363 1.1693 5.19717 1.67318C5.19725 1.67326 5.19733 1.67334 5.19741 1.67342ZM14 3.6249H13.1727C13.5056 3.15275 13.6076 2.51445 13.3487 1.91996L13.2489 1.69044C13.2489 1.69036 13.2489 1.69028 13.2488 1.69021C12.7578 0.541368 11.2642 0.259545 10.3869 1.13687L8.05995 3.46384L5.73298 1.13687C4.85565 0.259541 3.36211 0.541371 2.87107 1.69023C2.87104 1.6903 2.87101 1.69037 2.87098 1.69044L2.77119 1.91996C2.77118 1.91997 2.77118 1.91999 2.77117 1.92C2.5123 2.51447 2.61429 3.15276 2.94717 3.6249H1.99995C1.23853 3.6249 0.624951 4.23848 0.624951 4.99991V6.99991C0.624951 7.62502 1.05115 8.15969 1.62495 8.32739V12.9999C1.62495 14.3113 2.68853 15.3749 3.99995 15.3749H12C13.3114 15.3749 14.375 14.3113 14.375 12.9999V8.32742C14.9485 8.16039 15.375 7.63502 15.375 6.99991V4.99991C15.375 4.23848 14.7614 3.6249 14 3.6249ZM10.913 1.67294C11.4156 1.17037 12.2723 1.32826 12.5612 1.98992L12.6611 2.21956C12.9494 2.88925 12.4569 3.6249 11.73 3.6249H8.96102L10.913 1.67294ZM5.61495 14.6249H3.98995C3.09137 14.6249 2.36495 13.8985 2.36495 12.9999V8.37491H5.61495V14.6249ZM5.62495 7.62491H1.99995C1.65137 7.62491 1.37495 7.34848 1.37495 6.99991V4.99991C1.37495 4.65133 1.65137 4.37491 1.99995 4.37491H5.62495V7.62491ZM9.61495 14.6249H6.36495V4.37491H9.61495V14.6249ZM13.615 12.9999C13.615 13.8985 12.8885 14.6249 11.99 14.6249H10.365V8.37491H13.615V12.9999ZM14.615 6.99991C14.615 7.34848 14.3385 7.62491 13.99 7.62491H10.365V4.37491H13.99C14.3385 4.37491 14.615 4.65133 14.615 4.99991V6.99991Z'
        strokeWidth='0.15'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_11430'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

const Heart = ({ context = 'default', size = 16, ...props }: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M4.35005 2C5.73005 2 6.83005 3.12 7.24005 3.6C7.43005 3.82 7.71005 3.95 8.00005 3.95C8.29005 3.95 8.57005 3.82 8.76005 3.6C9.27005 3 10.3301 2 11.6501 2C12.0401 2 12.4401 2.09 12.8401 2.26C13.7801 2.68 14.4801 3.46 14.8101 4.46C15.1501 5.49 15.0301 6.62 14.5001 7.57C13.4301 9.46 11.2401 11.6 8.00005 13.92C4.76005 11.59 2.57005 9.46 1.50005 7.57C0.970054 6.63 0.850054 5.5 1.19005 4.46C1.51005 3.46 2.21005 2.68 3.16005 2.27C3.56005 2.09 3.96005 2 4.35005 2ZM11.6501 1C9.90005 1 8.59005 2.26 8.00005 2.95C7.41005 2.26 6.09005 1 4.35005 1C3.85005 1 3.32005 1.1 2.76005 1.35C1.55005 1.88 0.650054 2.88 0.240054 4.15C-0.179946 5.45 -0.0399464 6.87 0.630054 8.06C1.79005 10.11 4.14005 12.41 7.62005 14.88C7.73005 14.96 7.86005 15 7.99005 15H8.01005C8.14005 15 8.26005 14.96 8.37005 14.88C11.8601 12.41 14.2101 10.11 15.3701 8.06C16.0401 6.87 16.1801 5.45 15.7601 4.15C15.3401 2.88 14.4501 1.89 13.2501 1.35C12.6901 1.1 12.1501 1 11.6501 1Z' />
  </svg>
);

export const HeartDot = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_146_16921)'>
      <path d='M14.1692 7.62389C14.1304 7.70148 14.111 7.78876 14.0626 7.85665C13.0248 9.68961 10.9009 11.765 7.7587 14.015C4.61648 11.7553 2.49256 9.68961 1.45485 7.85665C0.940847 6.94501 0.824468 5.84911 1.15421 4.8405C1.46455 3.87068 2.14343 3.11421 3.06476 2.71659C3.45269 2.54202 3.84062 2.45473 4.21885 2.45473C5.5572 2.45473 6.62401 3.54094 7.02164 4.00645C7.2059 4.21981 7.47745 4.34589 7.7587 4.34589C8.03995 4.34589 8.3115 4.21981 8.49577 4.00645C8.68003 3.78339 8.95158 3.50214 9.28132 3.24999C9.36861 2.72628 9.56257 2.23168 9.84382 1.79525C8.8837 2.20258 8.14663 2.92025 7.7587 3.37607C7.18651 2.70689 5.90634 1.48491 4.21885 1.48491C3.73394 1.48491 3.21993 1.58189 2.67683 1.82435C1.50334 2.33836 0.630503 3.30818 0.232876 4.53985C-0.17445 5.80062 -0.0386746 7.17777 0.611107 8.33186C1.7361 10.32 4.01519 12.5506 7.39017 14.9461C7.49685 15.0236 7.62293 15.0624 7.749 15.0624H7.7684C7.89448 15.0624 8.01086 15.0236 8.11754 14.9461C11.5022 12.5506 13.7813 10.32 14.9063 8.33186C15.1391 7.92454 15.2845 7.47842 15.3815 7.0226C15.0227 7.29415 14.6057 7.48812 14.1692 7.61419V7.62389Z' />
      <path
        className={`icon__${context}--second-fill`}
        d='M13.0927 1C14.7026 1 16.0022 2.29956 16.0022 3.90947C16.0022 5.51938 14.7026 6.81894 13.0927 6.81894C11.4828 6.81894 10.1833 5.51938 10.1833 3.90947C10.1833 2.29956 11.4828 1 13.0927 1Z'
      />
    </g>
    <defs>
      <clipPath id='clip0_146_16921'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

const Home = ({ context = 'default', size = 16, ...props }: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M15.6 5.54L8.6 0.2C8.42 0.06 8.21 0 8 0C7.79 0 7.58 0.07 7.4 0.2L0.4 5.54C0.15 5.73 0 6.03 0 6.35V14.98C0 15.54 0.45 16 1 16H15C15.55 16 16 15.55 16 14.98V6.35C16 6.03 15.85 5.73 15.6 5.54ZM5 14.98V9.9C5 9.34 5.45 8.88 6 8.88H10C10.55 8.88 11 9.34 11 9.9V14.98H5ZM15 14.98H12V9.9C12 8.78 11.1 7.87 10 7.87H6C4.9 7.87 4 8.78 4 9.9V14.98H1V6.35L8 1.02L15 6.35V14.98Z' />
  </svg>
);

const Info = ({ context = 'default', size = 16, ...props }: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M8 0C3.56794 0 0 3.56794 0 8C0 12.4321 3.56794 16 8 16C12.4321 16 16 12.4321 16 8C16 3.56794 12.4321 0 8 0ZM8.93651 2.66667C9.24802 2.66667 9.50905 2.77493 9.72013 2.99095C9.93627 3.2071 10.0444 3.46813 10.0444 3.7747C10.0444 4.08127 9.93628 4.34267 9.72013 4.55867C9.5041 4.77481 9.24308 4.88295 8.93651 4.88295C8.63492 4.88295 8.37587 4.77482 8.15971 4.55867C7.94357 4.34264 7.83581 4.08124 7.83581 3.7747C7.83581 3.46816 7.94134 3.20711 8.1524 2.99095C8.36855 2.77493 8.62997 2.66667 8.93651 2.66667ZM9.40378 6.13429V6.22208C9.39497 6.22332 9.38629 6.22432 9.37749 6.22556L7.85838 11.4938C7.77294 11.8005 7.73015 12.0015 7.73015 12.097C7.73015 12.1523 7.75272 12.2047 7.79786 12.255C7.84312 12.3002 7.89111 12.3231 7.94134 12.3231C8.02678 12.3231 8.1803 12.3324 8.46216 12.1981C8.72369 12.0396 9.2955 11.6873 9.6121 11.1998L10.2222 11.5553C9.46343 12.877 8.05432 13.3331 7.20004 13.3331C6.8734 13.3331 6.26029 13.2424 6.06426 13.0615C5.87329 12.8756 5.7778 12.642 5.7778 12.3605C5.7778 12.1746 5.82046 11.9386 5.9059 11.6522L6.9539 8.04869C7.05435 7.70184 7.10457 7.61825 7.10457 7.44241C7.10457 7.33179 7.05695 7.2337 6.96147 7.14826C6.86598 7.06282 6.73528 7.02016 6.56947 7.02016C6.49407 7.02016 6.40342 7.01694 6.29789 7.0219L6.40007 6.57745C7.39401 6.44204 8.38483 6.36887 9.3775 6.22539L9.40378 6.13429Z' />
  </svg>
);

const Information = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 48 48'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M 24 4 C 12.972066 4 4 12.972074 4 24 C 4 35.027926 12.972066 44 24 44 C 35.027934 44 44 35.027926 44 24 C 44 12.972074 35.027934 4 24 4 z M 24 7 C 33.406615 7 41 14.593391 41 24 C 41 33.406609 33.406615 41 24 41 C 14.593385 41 7 33.406609 7 24 C 7 14.593391 14.593385 7 24 7 z M 24 14 A 2 2 0 0 0 24 18 A 2 2 0 0 0 24 14 z M 23.976562 20.978516 A 1.50015 1.50015 0 0 0 22.5 22.5 L 22.5 33.5 A 1.50015 1.50015 0 1 0 25.5 33.5 L 25.5 22.5 A 1.50015 1.50015 0 0 0 23.976562 20.978516 z' />
  </svg>
);

const Interests = ({ context = 'default', size = 16, ...props }: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M12.96 0H3.04C1.36 0 0 1.36 0 3.04V12.96C0 14.64 1.36 16 3.04 16H10.5C10.64 16 10.77 15.94 10.87 15.83L15.83 10.87C15.93 10.77 15.99 10.63 15.99 10.5V3.04C15.99 1.36 14.63 0 12.95 0H12.96ZM10.5 14.79V12.18C10.5 11.25 11.35 10.5 12.4 10.5H14.79L10.5 14.79ZM12.4 9.5C10.8 9.5 9.5 10.7 9.5 12.18V15H3.04C1.92 15 1 14.09 1 12.96V3.04C1 1.92 1.91 1 3.04 1H12.96C14.08 1 15 1.91 15 3.04V9.5H12.4Z' />
    <path d='M12 5H4C3.72 5 3.5 4.78 3.5 4.5C3.5 4.22 3.72 4 4 4H12C12.28 4 12.5 4.22 12.5 4.5C12.5 4.78 12.28 5 12 5Z' />
    <path d='M12 8H4C3.72 8 3.5 7.78 3.5 7.5C3.5 7.22 3.72 7 4 7H12C12.28 7 12.5 7.22 12.5 7.5C12.5 7.78 12.28 8 12 8Z' />
    <path d='M8 11H4C3.72 11 3.5 10.78 3.5 10.5C3.5 10.22 3.72 10 4 10H8C8.28 10 8.5 10.22 8.5 10.5C8.5 10.78 8.28 11 8 11Z' />
  </svg>
);

const Location = ({ context = 'default', size = 16, ...props }: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 14.0076L11.5581 8.38916C13.3678 5.53159 11.3465 1.77346 8 1.77346C4.65346 1.77346 2.63224 5.53159 4.44191 8.38916L8 14.0076ZM7.57271 14.7632C7.77266 15.0789 8.22734 15.0789 8.42729 14.7632L12.199 8.80741C14.3347 5.43509 11.9494 0.999999 8 0.999999C4.05063 1 1.66532 5.4351 3.80098 8.80741L7.57271 14.7632Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 7.25C8.69036 7.25 9.25 6.69036 9.25 6C9.25 5.30964 8.69036 4.75 8 4.75C7.30964 4.75 6.75 5.30964 6.75 6C6.75 6.69036 7.30964 7.25 8 7.25ZM8 8C9.10457 8 10 7.10457 10 6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6C6 7.10457 6.89543 8 8 8Z'
    />
  </svg>
);

const CelebraChat = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__fill'
      d='M18.2832 4.4248C19.132 4.4248 19.8201 5.11312 19.8203 5.96191V15.1846C19.8203 16.0335 19.1321 16.7217 18.2832 16.7217H17.4248L17.167 18.7832C17.0681 19.5729 16.083 19.8749 15.5586 19.2764L13.3232 16.7217H5.98633C5.13753 16.7215 4.44922 16.0334 4.44922 15.1846V5.96191C4.44939 5.11322 5.13763 4.42497 5.98633 4.4248H18.2832ZM5.98633 5.19336C5.5621 5.19352 5.21794 5.53769 5.21777 5.96191V15.1846C5.21777 15.6089 5.562 15.953 5.98633 15.9531H13.498C13.6088 15.9532 13.7142 16.0016 13.7871 16.085L16.1367 18.7695C16.2241 18.8694 16.3878 18.8192 16.4043 18.6875L16.7295 16.0879C16.7392 16.0112 16.8046 15.9533 16.8818 15.9531H18.2832C18.7077 15.9531 19.0518 15.609 19.0518 15.1846V5.96191C19.0516 5.53759 18.7076 5.19336 18.2832 5.19336H5.98633ZM9.06055 9.80469C9.48494 9.80469 9.82899 10.1489 9.8291 10.5732C9.8291 10.9977 9.48501 11.3418 9.06055 11.3418C8.63612 11.3417 8.29199 10.9977 8.29199 10.5732C8.29211 10.1489 8.63619 9.80474 9.06055 9.80469ZM12.1348 9.80469C12.5592 9.80469 12.9032 10.1489 12.9033 10.5732C12.9033 10.9977 12.5592 11.3418 12.1348 11.3418C11.7104 11.3416 11.3662 10.9976 11.3662 10.5732C11.3663 10.149 11.7105 9.80486 12.1348 9.80469ZM15.21 9.80469C15.6342 9.80493 15.9784 10.149 15.9785 10.5732C15.9785 10.9976 15.6342 11.3416 15.21 11.3418C14.7855 11.3418 14.4414 10.9977 14.4414 10.5732C14.4415 10.1489 14.7856 9.80469 15.21 9.80469Z'
    />
  </svg>
);

const NoOrders = ({ context = 'default', size = 16, ...props }: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 40 40'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M20.4565 5.46416L20.7047 5.03011L20.7047 5.03013L20.4565 5.46416ZM17.5435 5.46416L17.2953 5.03013L17.2953 5.03011L17.5435 5.46416ZM6.271 11.9108L6.02256 11.4769L6.02278 11.4768L6.271 11.9108ZM5.5 13.2607L6 13.2607V13.2607H5.5ZM5.5 25.9794L5 25.9796V25.9794H5.5ZM7.0435 28.6792L7.29169 28.2451L7.29182 28.2452L7.0435 28.6792ZM17.5435 34.6872L17.2953 35.1213L17.2952 35.1212L17.5435 34.6872ZM20.4565 34.6872L20.2083 34.2532C20.2162 34.2486 20.2242 34.2443 20.2323 34.2403L20.4565 34.6872ZM24.4425 32.1287C24.6893 32.0049 24.9898 32.1047 25.1136 32.3515C25.2374 32.5984 25.1376 32.8988 24.8908 33.0226L24.4425 32.1287ZM32.7271 12.2297C32.8641 12.4695 32.7807 12.7749 32.541 12.9118C32.3012 13.0488 31.9958 12.9654 31.8588 12.7257L32.7271 12.2297ZM31.729 11.9108L31.9772 11.4768L31.9774 11.4769L31.729 11.9108ZM25.5017 8.05733C25.7414 7.92021 26.0469 8.00337 26.184 8.24307C26.3211 8.48277 26.238 8.78823 25.9983 8.92534L25.5017 8.05733ZM12.25 16.2137H11.75C11.75 16.0344 11.8461 15.8688 12.0017 15.7797L12.25 16.2137ZM12.75 21.6194C12.75 21.8955 12.5261 22.1194 12.25 22.1194C11.9739 22.1194 11.75 21.8955 11.75 21.6194H12.75ZM20.2083 5.89821C19.8378 5.68633 19.422 5.57568 19 5.57568V4.57568C19.5974 4.57568 20.1841 4.73243 20.7047 5.03011L20.2083 5.89821ZM19 5.57568C18.578 5.57568 18.1622 5.68633 17.7917 5.89821L17.2953 5.03011C17.8159 4.73243 18.4026 4.57568 19 4.57568V5.57568ZM17.7917 5.8982L6.51922 12.3448L6.02278 11.4768L17.2953 5.03013L17.7917 5.8982ZM6.51945 12.3447C6.36432 12.4335 6.23322 12.5645 6.1412 12.7257L5.27285 12.2297C5.45194 11.9161 5.71027 11.6557 6.02256 11.4769L6.51945 12.3447ZM6.1412 12.7257C6.04911 12.8869 5.99999 13.0716 6 13.2607L5 13.2607C4.99998 12.899 5.09382 12.5431 5.27285 12.2297L6.1412 12.7257ZM6 13.2607V25.9794H5V13.2607H6ZM6 25.9793C6.0001 26.4438 6.12089 26.899 6.34876 27.2976L5.48063 27.7939C5.16572 27.2431 5.00014 26.6167 5 25.9796L6 25.9793ZM6.34876 27.2976C6.57657 27.6961 6.90264 28.0227 7.29169 28.2451L6.79531 29.1132C6.24898 28.8008 5.79559 28.3448 5.48063 27.7939L6.34876 27.2976ZM7.29182 28.2452L17.7918 34.2532L17.2952 35.1212L6.79518 29.1132L7.29182 28.2452ZM17.7917 34.2532C18.1622 34.465 18.578 34.5757 19 34.5757V35.5757C18.4026 35.5757 17.8159 35.4189 17.2953 35.1213L17.7917 34.2532ZM19 34.5757C19.422 34.5757 19.8378 34.465 20.2083 34.2532L20.7047 35.1213C20.1841 35.4189 19.5974 35.5757 19 35.5757V34.5757ZM20.2323 34.2403L24.4425 32.1287L24.8908 33.0226L20.6807 35.1341L20.2323 34.2403ZM31.8588 12.7257C31.7668 12.5645 31.6357 12.4335 31.4806 12.3447L31.9774 11.4769C32.2897 11.6557 32.5481 11.9161 32.7271 12.2297L31.8588 12.7257ZM31.4808 12.3448L20.2083 5.8982L20.7047 5.03013L31.9772 11.4768L31.4808 12.3448ZM25.9983 8.92534L12.4983 16.6477L12.0017 15.7797L25.5017 8.05733L25.9983 8.92534ZM12.75 16.2137V21.6194H11.75V16.2137H12.75ZM32.7483 12.7865L19.2483 20.5089L18.7517 19.6409L32.2517 11.9185L32.7483 12.7865ZM18.7517 20.5089L5.25173 12.7865L5.74826 11.9185L19.2483 19.6409L18.7517 20.5089ZM19.5 20.0749V34.7474H18.5V20.0749H19.5Z' />
    <path
      className='_stroke'
      d='M35.1668 31.7423L31.6113 28.0757M32.9076 24.7424C32.9076 27.3197 30.8763 29.409 28.3705 29.409C25.8648 29.409 23.8335 27.3197 23.8335 24.7424C23.8335 22.165 25.8648 20.0757 28.3705 20.0757C30.8763 20.0757 32.9076 22.165 32.9076 24.7424Z'
      fill='none'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const NumberSign = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14.325 8C14.325 11.4932 11.4932 14.325 8 14.325C4.5068 14.325 1.675 11.4932 1.675 8C1.675 4.5068 4.5068 1.675 8 1.675C11.4932 1.675 14.325 4.5068 14.325 8ZM8 15.075C11.9074 15.075 15.075 11.9074 15.075 8C15.075 4.09259 11.9074 0.925 8 0.925C4.09259 0.925 0.925 4.09259 0.925 8C0.925 11.9074 4.09259 15.075 8 15.075Z'
      strokeWidth='0.15'
    />
    <path
      d='M7.36375 4.09073C7.41399 3.88981 7.29183 3.68621 7.0909 3.63597C6.88998 3.58574 6.68638 3.7079 6.63615 3.90883L6.20716 5.62478H3.99995C3.79284 5.62478 3.62495 5.79267 3.62495 5.99978C3.62495 6.20688 3.79284 6.37478 3.99995 6.37478H6.01966L5.20716 9.62478H3.99995C3.79284 9.62478 3.62495 9.79267 3.62495 9.99978C3.62495 10.2069 3.79284 10.3748 3.99995 10.3748H5.01966L4.63615 11.9088C4.58592 12.1098 4.70808 12.3134 4.909 12.3636C5.10992 12.4138 5.31352 12.2917 5.36375 12.0907L5.79274 10.3748H9.01966L8.63615 11.9088C8.58592 12.1098 8.70808 12.3134 8.909 12.3636C9.10992 12.4138 9.31352 12.2917 9.36375 12.0907L9.79274 10.3748H12C12.2071 10.3748 12.375 10.2069 12.375 9.99978C12.375 9.79267 12.2071 9.62478 12 9.62478H9.98024L10.7927 6.37478H12C12.2071 6.37478 12.375 6.20688 12.375 5.99978C12.375 5.79267 12.2071 5.62478 12 5.62478H10.9802L11.3638 4.09073C11.414 3.88981 11.2918 3.68621 11.0909 3.63597C10.89 3.58574 10.6864 3.7079 10.6361 3.90883L10.2072 5.62478H6.98024L7.36375 4.09073L7.29099 4.07254L7.36375 4.09073ZM5.98024 9.62478L6.79274 6.37478H10.0197L9.20716 9.62478H5.98024Z'
      strokeWidth='0.15'
      strokeLinecap='round'
    />
  </svg>
);

const PackBeingProcessed = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 48 48'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M23.6023 8.41438L23.3554 7.97959L23.3554 7.9796L23.6023 8.41438ZM26.7311 8.41438L26.978 7.9796L26.978 7.97959L26.7311 8.41438ZM38.8386 15.2908L39.0857 14.8562L39.0855 14.856L38.8386 15.2908ZM39.6667 16.7307L39.1667 16.7306V16.7307H39.6667ZM39.6667 30.2973L40.1667 30.2975V30.2973H39.6667ZM38.0089 33.1771L37.762 32.7423L37.7618 32.7424L38.0089 33.1771ZM26.7311 39.5856L26.978 40.0204L26.9781 40.0203L26.7311 39.5856ZM23.6023 39.5856L23.8492 39.1508C23.8408 39.146 23.8322 39.1415 23.8235 39.1372L23.6023 39.5856ZM18.9436 36.7301C18.6959 36.608 18.3961 36.7097 18.2739 36.9574C18.1518 37.205 18.2535 37.5048 18.5012 37.627L18.9436 36.7301ZM10.4556 15.6462C10.3179 15.8855 10.4004 16.1912 10.6398 16.3289C10.8791 16.4666 11.1848 16.3841 11.3225 16.1447L10.4556 15.6462ZM11.4948 15.2908L11.2479 14.856L11.2476 14.8562L11.4948 15.2908ZM18.1637 11.2086C17.9236 11.0722 17.6183 11.1563 17.4819 11.3964C17.3455 11.6365 17.4296 11.9417 17.6697 12.0781L18.1637 11.2086ZM32.4167 19.8806H32.9167C32.9167 19.7007 32.8201 19.5347 32.6637 19.4458L32.4167 19.8806ZM31.9167 25.6466C31.9167 25.9228 32.1405 26.1466 32.4167 26.1466C32.6928 26.1466 32.9167 25.9228 32.9167 25.6466H31.9167ZM23.8492 8.84916C24.2529 8.6199 24.7063 8.5 25.1667 8.5V7.5C24.5322 7.5 23.9088 7.66532 23.3554 7.97959L23.8492 8.84916ZM25.1667 8.5C25.6271 8.5 26.0804 8.6199 26.4842 8.84916L26.978 7.97959C26.4246 7.66532 25.8012 7.5 25.1667 7.5V8.5ZM26.4841 8.84915L38.5917 15.7256L39.0855 14.856L26.978 7.9796L26.4841 8.84915ZM38.5914 15.7254C38.764 15.8236 38.9092 15.9679 39.0109 16.1447L39.8778 15.6462C39.6882 15.3166 39.4152 15.0435 39.0857 14.8562L38.5914 15.7254ZM39.0109 16.1447C39.1126 16.3216 39.1667 16.5239 39.1667 16.7306L40.1667 16.7307C40.1667 16.35 40.0672 15.9756 39.8778 15.6462L39.0109 16.1447ZM39.1667 16.7307V30.2973H40.1667V16.7307H39.1667ZM39.1667 30.2972C39.1666 30.7978 39.0355 31.2886 38.788 31.7186L39.6546 32.2175C39.99 31.6349 40.1665 30.972 40.1667 30.2975L39.1667 30.2972ZM38.788 31.7186C38.5404 32.1486 38.1858 32.5016 37.762 32.7423L38.2558 33.6119C38.8366 33.282 39.3191 32.8002 39.6546 32.2175L38.788 31.7186ZM37.7618 32.7424L26.4841 39.1509L26.9781 40.0203L38.2559 33.6118L37.7618 32.7424ZM26.4842 39.1508C26.0804 39.3801 25.6271 39.5 25.1667 39.5V40.5C25.8012 40.5 26.4246 40.3347 26.978 40.0204L26.4842 39.1508ZM25.1667 39.5C24.7063 39.5 24.2529 39.3801 23.8492 39.1508L23.3554 40.0204C23.9088 40.3347 24.5322 40.5 25.1667 40.5V39.5ZM23.8235 39.1372L18.9436 36.7301L18.5012 37.627L23.3811 40.034L23.8235 39.1372ZM11.3225 16.1447C11.4242 15.9679 11.5694 15.8236 11.7419 15.7254L11.2476 14.8562C10.9182 15.0435 10.6451 15.3166 10.4556 15.6462L11.3225 16.1447ZM11.7417 15.7256L23.8492 8.84915L23.3554 7.9796L11.2479 14.856L11.7417 15.7256ZM17.6697 12.0781L32.1697 20.3153L32.6637 19.4458L18.1637 11.2086L17.6697 12.0781ZM31.9167 19.8806V25.6466H32.9167V19.8806H31.9167ZM10.4197 16.1967L24.9197 24.4339L25.4137 23.5644L10.9137 15.3272L10.4197 16.1967ZM25.4137 24.4339L39.9137 16.1967L39.4197 15.3272L24.9197 23.5644L25.4137 24.4339ZM24.6667 23.9992V39.6499H25.6667V23.9992H24.6667Z' />
    <path
      className='_stroke'
      d='M14.1667 23H7.66669M17.4167 34L7.66669 34M20.6667 28.5H12.5417'
      stroke='#181818'
      strokeLinecap='round'
    />
  </svg>
);

const Plus = ({ context = 'default', size = 16, ...props }: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 45.4 45.4'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g>
      <path d='M41.267,18.557H26.832V4.134C26.832,1.851,24.99,0,22.707,0c-2.283,0-4.124,1.851-4.124,4.135v14.432H4.141   c-2.283,0-4.139,1.851-4.138,4.135c-0.001,1.141,0.46,2.187,1.207,2.934c0.748,0.749,1.78,1.222,2.92,1.222h14.453V41.27   c0,1.142,0.453,2.176,1.201,2.922c0.748,0.748,1.777,1.211,2.919,1.211c2.282,0,4.129-1.851,4.129-4.133V26.857h14.435   c2.283,0,4.134-1.867,4.133-4.15C45.399,20.425,43.548,18.557,41.267,18.557z' />
    </g>
  </svg>
);

const Profile = ({ context = 'default', size = 16, ...props }: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M8 0C3.58 0 0 3.58 0 8C0 12.42 3.58 16 8 16C12.42 16 16 12.42 16 8C16 3.58 12.42 0 8 0ZM8 1C11.86 1 15 4.14 15 8C15 9.48 14.54 10.85 13.75 11.98C12.87 10.31 11.28 9.06 9.38 8.65C10.34 8.15 11 7.16 11 6C11 4.34 9.66 3 8 3C6.34 3 5 4.34 5 6C5 7.16 5.66 8.15 6.62 8.65C4.72 9.06 3.13 10.31 2.25 11.99C1.46 10.86 1 9.48 1 8C1 4.14 4.14 1 8 1ZM8 8C6.9 8 6 7.1 6 6C6 4.9 6.9 4 8 4C9.1 4 10 4.9 10 6C10 7.1 9.1 8 8 8ZM8 15C6.02 15 4.23 14.17 2.96 12.84C3.8 10.88 5.74 9.5 8 9.5C10.26 9.5 12.2 10.88 13.04 12.84C11.77 14.17 9.98 15 8 15Z' />
  </svg>
);

export const ProfileNotification = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.1254 12.9012C12.2972 11.3295 11.036 10.6047 9.24778 10.2189C10.1513 9.74828 10.7725 8.81652 10.7725 7.72475C10.7725 6.1624 9.51131 4.90123 7.94896 4.90123C6.3866 4.90123 5.12543 6.1624 5.12543 7.72475C5.12543 8.81652 5.7466 9.74828 6.65013 10.2189C4.8619 10.6047 3.36543 11.7812 2.5372 13.3624V13.8424L3.20543 14.1624C3.99602 12.3177 5.8219 11.0189 7.94896 11.0189C10.076 11.0189 11.9019 12.3177 12.6925 14.1624L13.1254 13.6119L13.1254 12.9012ZM6.0666 7.72475C6.0666 8.76005 6.91366 9.6071 7.94896 9.6071C8.98425 9.6071 9.83131 8.76005 9.83131 7.72475C9.83131 6.68946 8.98425 5.8424 7.94896 5.8424C6.91366 5.8424 6.0666 6.68946 6.0666 7.72475Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.35473 13.3149C4.54949 14.3591 6.06122 14.9704 7.646 15.0499C9.23077 15.1295 10.7961 14.6728 12.0895 13.7535C13.3828 12.8342 14.3287 11.506 14.7745 9.98314C15.2203 8.46029 15.14 6.83164 14.5466 5.36002C14.4494 5.11899 14.566 4.84479 14.807 4.74759C15.048 4.65039 15.3222 4.76699 15.4194 5.00803C16.092 6.67586 16.183 8.52166 15.6778 10.2476C15.1726 11.9735 14.1005 13.4788 12.6347 14.5207C11.1689 15.5625 9.39487 16.0801 7.5988 15.9899C5.80272 15.8997 4.08942 15.207 2.73536 14.0236C1.38131 12.8401 0.46549 11.235 0.135691 9.46713C-0.194109 7.69929 0.0813509 5.87189 0.917617 4.27983C1.75388 2.68776 3.10218 1.42389 4.74492 0.692173C6.38766 -0.0395455 8.22904 -0.196431 9.97189 0.246833C10.2238 0.310894 10.376 0.567016 10.312 0.818895C10.2479 1.07077 9.99178 1.22303 9.7399 1.15897C8.20209 0.767855 6.57735 0.906283 5.12787 1.55192C3.67839 2.19755 2.48872 3.31273 1.75084 4.71749C1.01296 6.12226 0.769905 7.73467 1.0609 9.29452C1.3519 10.8544 2.15998 12.2707 3.35473 13.3149Z'
    />
    <path
      className={`icon__${context}--second-fill`}
      d='M12.4285 0.195347C13.9437 0.195347 15.1668 1.41846 15.1668 2.93367C15.1668 4.44887 13.9437 5.67199 12.4285 5.67199C10.9133 5.67199 9.69013 4.44887 9.69013 2.93367C9.69013 1.41846 10.9133 0.195347 12.4285 0.195347Z'
    />
  </svg>
);

export const ReturnProductOnline = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 41 40'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g>
      <path d='M20.7973 5.38848L21.0455 4.95443L21.0455 4.95444L20.7973 5.38848ZM17.8843 5.38848L17.6361 4.95444L17.6361 4.95443L17.8843 5.38848ZM6.61182 11.8351L6.36338 11.4012L6.3636 11.4011L6.61182 11.8351ZM5.84082 13.185L6.34082 13.185V13.185H5.84082ZM5.84082 25.9038L5.34082 25.9039V25.9038H5.84082ZM7.38432 28.6035L7.63251 28.1695L7.63264 28.1695L7.38432 28.6035ZM17.8843 34.6115L17.6361 35.0456L17.636 35.0455L17.8843 34.6115ZM20.7973 34.6115L20.5491 34.1775C20.557 34.173 20.565 34.1687 20.5732 34.1646L20.7973 34.6115ZM24.7833 32.0531C25.0301 31.9293 25.3306 32.029 25.4544 32.2758C25.5782 32.5227 25.4785 32.8231 25.2316 32.9469L24.7833 32.0531ZM33.068 12.154C33.2049 12.3938 33.1216 12.6992 32.8818 12.8362C32.642 12.9731 32.3366 12.8898 32.1996 12.65L33.068 12.154ZM32.0698 11.8351L32.318 11.4011L32.3183 11.4012L32.0698 11.8351ZM25.8426 7.98164C26.0823 7.84453 26.3877 7.92769 26.5248 8.16739C26.6619 8.40708 26.5788 8.71255 26.3391 8.84966L25.8426 7.98164ZM12.5908 16.138H12.0908C12.0908 15.9587 12.1869 15.7931 12.3426 15.704L12.5908 16.138ZM13.0908 21.5437C13.0908 21.8198 12.867 22.0437 12.5908 22.0437C12.3147 22.0437 12.0908 21.8198 12.0908 21.5437H13.0908ZM20.5491 5.82253C20.1786 5.61064 19.7628 5.5 19.3408 5.5V4.5C19.9382 4.5 20.5249 4.65675 21.0455 4.95443L20.5491 5.82253ZM19.3408 5.5C18.9189 5.5 18.5031 5.61064 18.1325 5.82253L17.6361 4.95443C18.1567 4.65675 18.7434 4.5 19.3408 4.5V5.5ZM18.1325 5.82251L6.86004 12.2692L6.3636 11.4011L17.6361 4.95444L18.1325 5.82251ZM6.86027 12.269C6.70514 12.3578 6.57404 12.4888 6.48202 12.65L5.61367 12.154C5.79276 11.8405 6.05109 11.58 6.36338 11.4012L6.86027 12.269ZM6.48202 12.65C6.38993 12.8112 6.34081 12.996 6.34082 13.185L5.34082 13.185C5.34081 12.8234 5.43464 12.4675 5.61367 12.154L6.48202 12.65ZM6.34082 13.185V25.9038H5.34082V13.185H6.34082ZM6.34082 25.9036C6.34093 26.3681 6.46171 26.8233 6.68958 27.2219L5.82145 27.7182C5.50654 27.1674 5.34097 26.541 5.34082 25.9039L6.34082 25.9036ZM6.68958 27.2219C6.91739 27.6204 7.24346 27.947 7.63251 28.1695L7.13613 29.0376C6.5898 28.7252 6.13641 28.2691 5.82145 27.7182L6.68958 27.2219ZM7.63264 28.1695L18.1326 34.1775L17.636 35.0455L7.136 29.0375L7.63264 28.1695ZM18.1325 34.1775C18.5031 34.3894 18.9189 34.5 19.3408 34.5V35.5C18.7435 35.5 18.1567 35.3433 17.6361 35.0456L18.1325 34.1775ZM19.3408 34.5C19.7628 34.5 20.1786 34.3894 20.5491 34.1775L21.0455 35.0456C20.5249 35.3433 19.9382 35.5 19.3408 35.5V34.5ZM20.5732 34.1646L24.7833 32.0531L25.2316 32.9469L21.0215 35.0585L20.5732 34.1646ZM32.1996 12.65C32.1076 12.4888 31.9765 12.3578 31.8214 12.269L32.3183 11.4012C32.6306 11.58 32.8889 11.8405 33.068 12.154L32.1996 12.65ZM31.8216 12.2692L20.5491 5.82251L21.0455 4.95444L32.318 11.4011L31.8216 12.2692ZM26.3391 8.84966L12.8391 16.572L12.3426 15.704L25.8426 7.98164L26.3391 8.84966ZM13.0908 16.138V21.5437H12.0908V16.138H13.0908ZM33.0891 12.7109L19.5891 20.4332L19.0926 19.5652L32.5926 11.8428L33.0891 12.7109ZM19.0926 20.4332L5.59255 12.7109L6.08908 11.8428L19.5891 19.5652L19.0926 20.4332ZM19.8408 19.9992V34.6718H18.8408V19.9992H19.8408Z' />
      <path
        className='icon__nofill'
        d='M33.1204 35C43.3421 35 40.7868 20.5556 24.1738 22.963M24.1738 22.963L29.764 27.5926M24.1738 22.963L29.764 18.3333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
  </svg>
);

export const ReturnProductInStore = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 40 40'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g>
      <path
        className='icon__nofill'
        d='M8.26667 5.85333L6.24445 8.62666C5.84391 9.17597 5.64364 9.45062 5.64829 9.68052C5.65233 9.88059 5.74353 10.0682 5.89671 10.1916C6.07274 10.3333 6.40652 10.3333 7.07407 10.3333H26.2593C26.9268 10.3333 27.2606 10.3333 27.4366 10.1916C27.5898 10.0682 27.681 9.88059 27.685 9.68052C27.6897 9.45062 27.4894 9.17597 27.0889 8.62666L25.0667 5.85333M8.26667 5.85333C8.49481 5.54045 8.60889 5.384 8.75346 5.27117C8.8815 5.17123 9.0265 5.09666 9.18106 5.05126C9.35556 5 9.54568 5 9.92593 5H23.4074C23.7877 5 23.9778 5 24.1523 5.05126C24.3068 5.09666 24.4518 5.17123 24.5799 5.27117C24.7244 5.384 24.8385 5.54045 25.0667 5.85333M8.26667 5.85333L5.82963 9.19555C5.52181 9.61771 5.3679 9.82878 5.25861 10.0612C5.16163 10.2675 5.0909 10.4857 5.04816 10.7106C5 10.964 5 11.2279 5 11.7556L5 27.4C5 28.8935 5 29.6402 5.28258 30.2106C5.53114 30.7124 5.92775 31.1204 6.41558 31.376C6.97017 31.6667 7.69616 31.6667 9.14815 31.6667H20.3331M25.0667 5.85333L27.5037 9.19556C27.8115 9.61771 27.9654 9.82878 28.0747 10.0612C28.1717 10.2675 28.2424 10.4858 28.2852 10.7106C28.3333 10.964 28.3333 11.2279 28.3333 11.7556V19.4379M21.8519 15.6667C21.8519 17.0812 21.3056 18.4377 20.3331 19.4379C19.3607 20.4381 18.0419 21 16.6667 21C15.2915 21 13.9726 20.4381 13.0002 19.4379C12.0278 18.4377 11.4815 17.0812 11.4815 15.6667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='icon__nofill'
        d='M29.2977 35C36.1122 35 34.4086 24.8889 23.3333 26.5741M23.3333 26.5741L27.0601 29.8148M23.3333 26.5741L27.0601 23.3333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
  </svg>
);

export const RingHeart = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M10.86 3.77993C10.86 3.77993 10.88 3.75993 10.88 3.74993C11.15 3.26993 11.21 2.70993 11.05 2.18993C10.87 1.66993 10.49 1.24993 9.99 1.03993C9.15 0.689929 8.43 1.05993 8 1.44993C7.56 1.05993 6.84 0.689929 6.01 1.03993C5.51 1.25993 5.12 1.67993 4.95 2.18993C4.77 2.70993 4.84 3.27993 5.12 3.75993C5.12 3.75993 5.14 3.77993 5.14 3.78993C3.27 4.80993 2 6.76993 2 9.04993C2 12.3599 4.69 15.0499 8 15.0499C11.31 15.0499 14 12.3599 14 9.04993C14 6.77993 12.73 4.80993 10.86 3.78993V3.77993ZM7.36 2.00993C7.45 2.07993 7.52 2.15993 7.57 2.20993C7.59 2.23993 7.61 2.25993 7.63 2.27993C7.64 2.29993 7.65 2.30993 7.65 2.30993C7.73 2.41993 7.85 2.48993 8 2.48993C8.15 2.48993 8.27 2.41993 8.35 2.30993L8.38 2.26993C8.38 2.26993 8.42 2.21993 8.45 2.17993C8.52 2.10993 8.61 2.00993 8.74 1.92993C8.98 1.75993 9.3 1.64993 9.66 1.80993C9.95 1.92993 10.15 2.15993 10.25 2.44993C10.35 2.73993 10.31 3.04993 10.16 3.30993C9.81 3.89993 9.1 4.57993 8.01 5.34993C6.93 4.58993 6.21 3.90993 5.86 3.31993C5.7 3.05993 5.67 2.73993 5.77 2.44993C5.87 2.15993 6.07 1.92993 6.36 1.81993C6.49 1.75993 6.6 1.73993 6.71 1.73993C6.97 1.73993 7.21 1.86993 7.38 2.01993L7.36 2.00993ZM7.7 6.17993C7.79 6.24993 7.9 6.26993 7.99 6.26993C8.08 6.26993 8.19 6.24993 8.28 6.17993C8.43 6.07993 8.55 5.97993 8.69 5.87993C10.14 6.20993 11.23 7.48993 11.23 9.03993C11.23 10.8299 9.77 12.2899 7.98 12.2899C6.19 12.2899 4.73 10.8299 4.73 9.03993C4.73 7.48993 5.82 6.19993 7.28 5.87993C7.42 5.97993 7.54 6.07993 7.69 6.17993H7.7ZM7.99 14.2899C5.09 14.2899 2.74 11.9399 2.74 9.03993C2.74 7.00993 3.9 5.25993 5.58 4.38993C5.84 4.68993 6.17 4.99993 6.56 5.31993C5.06 5.89993 3.99 7.33993 3.99 9.03993C3.99 11.2499 5.78 13.0399 7.99 13.0399C10.2 13.0399 11.99 11.2499 11.99 9.03993C11.99 7.33993 10.92 5.89993 9.43 5.31993C9.81 4.99993 10.14 4.68993 10.4 4.38993C12.08 5.26993 13.24 7.00993 13.24 9.03993C13.24 11.9399 10.89 14.2899 7.99 14.2899Z' />
  </svg>
);

const ShipmentCancelledStage = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.00006 16C12.4183 16 16.0001 12.4183 16.0001 8C16.0001 3.58172 12.4183 0 8.00006 0C3.58178 0 6.10352e-05 3.58172 6.10352e-05 8C6.10352e-05 12.4183 3.58178 16 8.00006 16ZM5.8996 4.76817C5.58718 4.45575 5.08065 4.45575 4.76823 4.76817C4.45581 5.08059 4.45581 5.58712 4.76823 5.89954L6.86921 8.00052L4.76823 10.1015C4.45581 10.4139 4.45581 10.9205 4.76823 11.2329C5.08065 11.5453 5.58718 11.5453 5.8996 11.2329L8.00058 9.13189L10.1016 11.2329C10.414 11.5453 10.9205 11.5453 11.2329 11.2329C11.5454 10.9205 11.5454 10.4139 11.2329 10.1015L9.13195 8.00052L11.2329 5.89954C11.5454 5.58712 11.5454 5.08059 11.2329 4.76817C10.9205 4.45575 10.414 4.45575 10.1016 4.76817L8.00058 6.86915L5.8996 4.76817Z'
    />
  </svg>
);

const ShipmentCheckedStage = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M8 0C3.58172 0 0 3.58182 0 8C0 12.4183 3.58182 16 8 16C12.4183 16 16 12.4182 16 8C16 3.58172 12.4184 0 8 0ZM12.3804 6.6537L7.48162 11.5525C7.15835 11.8757 6.63438 11.8757 6.31108 11.5525L3.61941 8.86079C3.29613 8.53751 3.29613 8.01355 3.61941 7.69025L3.82819 7.48146C4.15147 7.15819 4.67543 7.15819 4.99873 7.48146L6.89661 9.379L11.0012 5.27437C11.3245 4.95109 11.8485 4.95109 12.1718 5.27437L12.3806 5.48315C12.7035 5.80662 12.7035 6.33079 12.3804 6.6537H12.3804Z' />
  </svg>
);

const ShipmentDelivered = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 48 48'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke'
      d='M29.2059 38.1677V31.6956C29.2059 30.2235 28.0072 29.0431 26.5422 29.0431H21.7078C20.2295 29.0431 19.0441 30.2367 19.0441 31.6956V38.1677C19.0441 38.5391 18.7511 38.8309 18.3782 38.8309H16.3272C13.3839 38.8309 11 36.4569 11 33.5258V19.6266C11 18.8044 11.3862 18.0219 12.0388 17.5179L22.4802 9.54708C23.4391 8.81764 24.7709 8.81764 25.7165 9.54708L36.1979 17.5312C36.8638 18.0351 37.25 18.8176 37.25 19.6399V33.5391C37.25 36.4701 34.8661 38.8441 31.9228 38.8441H29.8718C29.4989 38.8441 29.2059 38.5524 29.2059 38.181V38.1677Z'
      stroke='#181818'
      strokeMiterlimit='10'
      fillOpacity='0'
    />
    <path
      className='_stroke'
      d='M22 39L26 39'
      stroke='#181818'
      strokeMiterlimit='10'
      strokeLinecap='round'
      fillOpacity='0'
    />
  </svg>
);

const ShipmentSendPackage = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 48 48'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke'
      d='M7.42541 35.5677C6.26476 35.5677 5.33337 34.7003 5.33337 33.6264V14.407C5.33337 11.8585 6.27909 10.5 7.42541 10.5H24.0184C32.2147 10.5 32.5872 16.3322 32.5872 17.7641V27.0949'
      stroke='#181818'
      strokeMiterlimit='10'
      strokeLinecap='round'
      fillOpacity='0'
    />
    <path
      className='_stroke'
      d='M35.6146 17.873H37.0783C38.1416 17.873 39.6516 18.3646 40.5709 20.3734C40.5709 20.3734 43.0363 26.7205 43.1845 27.7036C43.3326 28.6866 43.3326 30.1982 43.3326 30.6017C43.3326 31.0051 43.3326 33.2913 43.3326 33.2913C43.3326 34.7705 42.1036 35.9808 40.5709 35.9808H37.7678'
      stroke='#181818'
      strokeMiterlimit='10'
      strokeLinecap='round'
      fillOpacity='0'
    />
    <path
      className='_stroke'
      d='M31.578 39.4992C33.8079 39.4992 35.6156 37.7387 35.6156 35.567C35.6156 33.3953 33.8079 31.6348 31.578 31.6348C29.3481 31.6348 27.5404 33.3953 27.5404 35.567C27.5404 37.7387 29.3481 39.4992 31.578 39.4992Z'
      stroke='#181818'
      strokeMiterlimit='10'
      strokeLinecap='round'
      fillOpacity='0'
    />
    <path
      className='_stroke'
      d='M13.4061 39.4992C15.636 39.4992 17.4437 37.7387 17.4437 35.567C17.4437 33.3953 15.636 31.6348 13.4061 31.6348C11.1762 31.6348 9.36853 33.3953 9.36853 35.567C9.36853 37.7387 11.1762 39.4992 13.4061 39.4992Z'
      stroke='#181818'
      strokeMiterlimit='10'
      strokeLinecap='round'
      fillOpacity='0'
    />
    <path
      className='_stroke'
      d='M20.474 35.5684L24.5116 35.5684'
      stroke='#181818'
      strokeMiterlimit='10'
      strokeLinecap='round'
      fillOpacity='0'
    />
    <path
      className='_stroke'
      d='M5.33337 27.7031H24.512'
      stroke='#181818'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
  </svg>
);

const ShipmentUnreachedStage = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      opacity='0.3'
      d='M8.00006 4.44434C6.03638 4.44434 4.4445 6.03626 4.4445 7.99989C4.4445 9.96357 6.03642 11.5554 8.00006 11.5554C9.96374 11.5554 11.5556 9.96353 11.5556 7.99989C11.5556 6.03621 9.96378 4.44434 8.00006 4.44434Z'
    />
    <path d='M8.00007 6.22266C7.01823 6.22266 6.22229 7.01862 6.22229 8.00043C6.22229 8.98227 7.01825 9.77821 8.00007 9.77821C8.98191 9.77821 9.77785 8.98225 9.77785 8.00043C9.77785 7.01859 8.98193 6.22266 8.00007 6.22266Z' />
  </svg>
);

const Shipping = ({ context = 'default', size = 16, ...props }: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.375 2.75H12C12.6904 2.75 13.25 3.30964 13.25 4V12C13.25 12.6904 12.6904 13.25 12 13.25H4C3.30964 13.25 2.75 12.6904 2.75 12V4C2.75 3.30964 3.30964 2.75 4 2.75H4.625V9.6263C4.625 10.0855 5.13683 10.3595 5.51895 10.1047L8 8.45069L10.481 10.1047C10.8632 10.3595 11.375 10.0855 11.375 9.6263V2.75ZM10.625 2.75H5.375V9.29931L7.68105 7.76194C7.87419 7.63318 8.12581 7.63318 8.31895 7.76194L10.625 9.29931V2.75ZM2 4C2 2.89543 2.89543 2 4 2H12C13.1046 2 14 2.89543 14 4V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V4Z'
    />
  </svg>
);

const SuccessFilled = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 17 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_6712_7622)'>
      <path d='M8.84082 0C4.42082 0 0.84082 3.58 0.84082 8C0.84082 12.42 4.42082 16 8.84082 16C13.2608 16 16.8408 12.42 16.8408 8C16.8408 3.58 13.2608 0 8.84082 0ZM13.0808 5.57L7.56082 11.08C7.42082 11.22 7.24082 11.29 7.07082 11.29C6.90082 11.29 6.71082 11.22 6.57082 11.08L4.59082 9.1C4.39082 8.9 4.39082 8.59 4.59082 8.39C4.79082 8.19 5.10082 8.19 5.30082 8.39L7.07082 10.16L12.3708 4.86C12.5708 4.66 12.8808 4.66 13.0808 4.86C13.2808 5.06 13.2808 5.37 13.0808 5.57Z' />
    </g>
    <defs>
      <clipPath id='clip0_6712_7622'>
        <rect width='16' height='16' transform='translate(0.84082)' />
      </clipPath>
    </defs>
  </svg>
);

const Trash = ({ context = 'default', size = 16, ...props }: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 19'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.66664 2.03561H1.33333C0.596721 2.03561 0 2.64296 0 3.39269V4.74976C0 5.49949 0.596721 6.10684 1.33333 6.10684H1.37127L2.00997 17.0836C2.07262 18.1598 2.94806 18.9991 4.00669 18.9991H11.9933C13.0519 18.9991 13.9274 18.1598 13.99 17.0836L14.6287 6.10684H14.6667C15.4033 6.10684 16 5.49949 16 4.74976V3.39269C16 2.64296 15.4033 2.03561 14.6667 2.03561H11.3334V1.35708C11.3334 0.607349 10.7366 0 10 0H6.00005C5.26345 0 4.66672 0.607349 4.66672 1.35708L4.66664 2.03561ZM2.70726 6.10684H13.2927L12.6586 17.0034C12.638 17.3623 12.346 17.6419 11.9933 17.6419H4.00668C3.65401 17.6419 3.36204 17.3623 3.34135 17.0034L2.70726 6.10684ZM14.6664 3.39269H1.33317V4.74976H14.6664V3.39269ZM5.99982 2.03561H9.99979V1.35708H5.99982V2.03561Z'
    />
  </svg>
);

const Warning = ({ context = 'default', size = 16, ...props }: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M6.86001 2.57335L1.21335 12C1.09693 12.2016 1.03533 12.4302 1.03467 12.663C1.03402 12.8958 1.09434 13.1248 1.20963 13.327C1.32492 13.5293 1.49116 13.6978 1.69182 13.8159C1.89247 13.934 2.12055 13.9975 2.35335 14H13.6467C13.8795 13.9975 14.1076 13.934 14.3082 13.8159C14.5089 13.6978 14.6751 13.5293 14.7904 13.327C14.9057 13.1248 14.966 12.8958 14.9654 12.663C14.9647 12.4302 14.9031 12.2016 14.7867 12L9.14001 2.57335C9.02117 2.37742 8.85383 2.21543 8.65414 2.103C8.45446 1.99058 8.22917 1.93152 8.00001 1.93152C7.77086 1.93152 7.54557 1.99058 7.34588 2.103C7.1462 2.21543 6.97886 2.37742 6.86001 2.57335V2.57335Z'
      stroke='#FF7F11'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      className='_stroke icon__nofill'
      d='M8 6V8.66667'
      stroke='#FF7F11'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      className='_stroke icon__nofill'
      d='M8 11.3333H8.0075'
      stroke='#FF7F11'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
  </svg>
);

const AlertError = ({ context = 'default', size = 16, ...props }: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <circle
      className='_stroke icon__nofill'
      cx='8.00065'
      cy='8.5'
      r='6.16667'
      stroke='#E83131'
    />
    <path
      className='_stroke icon__nofill'
      d='M4.66602 5.16667L11.3327 11.8333M11.3327 5.16667L4.66602 11.8333'
      stroke='#E83131'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const Error = ({ context = 'default', size = 16, ...props }: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 60 60'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g>
      <circle
        className='_stroke icon__nofill'
        cx='29.3405'
        cy='28.9999'
        r='23.6667'
      />
      <path
        className='_stroke icon__nofill'
        d='M19 19 L40 40 M40 19 L19 40'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
  </svg>
);

const AlertSuccess = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <circle
      className='_stroke icon__nofill'
      cx='7.99992'
      cy='8.00016'
      r='6.16667'
      stroke='#08B879'
    />
    <path
      className='_stroke icon__nofill'
      d='M4.66675 8.46914L6.71803 10.4444L11.3334 6'
      stroke='#08B879'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const Success = ({ context = 'default', size = 16, ...props }: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 59 58'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g>
      <circle
        className='_stroke icon__nofill'
        cx='29.3405'
        cy='28.9999'
        r='23.6667'
      />
      <path
        className='_stroke icon__nofill'
        d='M17.2559 30.7006L24.6918 37.8611L41.4225 21.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
  </svg>
);

const HeartFilled = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14.9375 4.26709C14.9375 8.91553 8.0452 12.6781 7.75168 12.8335C7.67432 12.8751 7.58784 12.8969 7.5 12.8969C7.41216 12.8969 7.32568 12.8751 7.24832 12.8335C6.9548 12.6781 0.0625 8.91553 0.0625 4.26709C0.0637303 3.17552 0.497899 2.12901 1.26976 1.35716C2.04161 0.585302 3.08812 0.151133 4.17969 0.149902C5.55098 0.149902 6.7516 0.73959 7.5 1.73635C8.2484 0.73959 9.44902 0.149902 10.8203 0.149902C11.9119 0.151133 12.9584 0.585302 13.7302 1.35716C14.5021 2.12901 14.9363 3.17552 14.9375 4.26709Z'
      fill='currentcolor'
    />
  </svg>
);

const ImageSearch = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 32 32'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M28.5654 13.2489C28.5654 12.2469 27.7531 11.4346 26.7511 11.4346L23.3755 11.4346L23.3755 10L26.7511 10C28.5454 10 30 11.4546 30 13.2489L30 16.6244L28.5654 16.6244L28.5654 13.2489Z'
      fill='currentcolor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.4346 13.2489C11.4346 12.2469 12.2469 11.4346 13.2489 11.4346L16.6245 11.4346L16.6245 10L13.2489 10C11.4546 10 10 11.4546 10 13.2489L10 16.6244L11.4346 16.6244L11.4346 13.2489Z'
      fill='currentcolor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M26.7511 28.5654C27.7531 28.5654 28.5654 27.7531 28.5654 26.7511L28.5654 23.3756L30 23.3756L30 26.7511C30 28.5454 28.5454 30 26.7511 30L23.3755 30L23.3755 28.5654L26.7511 28.5654Z'
      fill='currentcolor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.4346 26.7511C11.4346 27.7531 12.2469 28.5654 13.2489 28.5654L16.6245 28.5654L16.6245 30L13.2489 30C11.4546 30 10 28.5454 10 26.7511L10 23.3756L11.4346 23.3756L11.4346 26.7511Z'
      fill='currentcolor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22.1104 19.3698C22.1104 20.8833 20.8834 22.1103 19.3698 22.1103C17.8562 22.1103 16.6292 20.8833 16.6292 19.3698C16.6292 17.8562 17.8562 16.6292 19.3698 16.6292C20.8834 16.6292 22.1104 17.8562 22.1104 19.3698ZM21.7644 22.7626C21.0877 23.241 20.2616 23.5221 19.3698 23.5221C17.0765 23.5221 15.2174 21.6631 15.2174 19.3698C15.2174 17.0765 17.0765 15.2174 19.3698 15.2174C21.6631 15.2174 23.5222 17.0765 23.5222 19.3698C23.5222 20.2615 23.2411 21.0876 22.7627 21.7643L25.6823 24.6839L24.684 25.6822L21.7644 22.7626Z'
      fill='currentcolor'
    />
  </svg>
);

const FacetsFilter = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.86694 1.56199C6.70328 1.73896 7.33349 2.50823 7.33349 3.42869C7.33349 4.34942 6.70302 5.11845 5.86694 5.29518V15.6188C5.86694 15.8293 5.70274 15.9999 5.50016 15.9999C5.29759 15.9999 5.13338 15.8293 5.13338 15.6188V5.29518C4.29704 5.11847 3.66683 4.34921 3.66683 3.42869C3.66683 2.50768 4.2973 1.73892 5.13338 1.56219V0.381054C5.13338 0.170595 5.29759 0 5.50016 0C5.70274 0 5.86694 0.170595 5.86694 0.381054V1.56199ZM4.40012 3.42869C4.40012 4.05872 4.89324 4.57159 5.5002 4.57159C6.10663 4.57159 6.60028 4.05927 6.60028 3.42869C6.60028 2.79865 6.10716 2.28578 5.5002 2.28578C4.89377 2.28578 4.40012 2.7981 4.40012 3.42869ZM2.20012 10.7047C3.03646 10.8814 3.66667 11.6507 3.66667 12.5712C3.66667 13.4922 3.0362 14.261 2.20012 14.4377V15.6189C2.20012 15.8293 2.03591 15.9999 1.83334 15.9999C1.63077 15.9999 1.46682 15.8293 1.46682 15.6189V14.438C0.630217 14.261 0 13.4918 0 12.5713C0 11.6506 0.630727 10.8815 1.46682 10.7048V0.381171C1.46682 0.170712 1.63077 0.000116244 1.83334 0.000116244C2.03591 0.000116244 2.20012 0.170712 2.20012 0.381171V10.7047ZM0.733298 12.5712C0.733298 13.2013 1.22642 13.7141 1.83338 13.7141C2.43981 13.7141 2.93346 13.2018 2.93346 12.5712C2.93346 11.9412 2.44034 11.4283 1.83338 11.4283C1.22695 11.4283 0.733298 11.9406 0.733298 12.5712ZM11 9.14291C11 8.22245 10.3698 7.45318 9.53316 7.27621V0.381299C9.53316 0.17084 9.36921 0.000244141 9.16664 0.000244141C8.96407 0.000244141 8.79986 0.17084 8.79986 0.381299V7.27641C7.96378 7.45315 7.33331 8.22191 7.33331 9.14291C7.33331 10.0634 7.96352 10.8327 8.79986 11.0094V15.619C8.79986 15.8294 8.96407 16 9.16664 16C9.36921 16 9.53316 15.8294 9.53316 15.619V11.0094C10.3693 10.8327 11 10.0636 11 9.14291ZM9.16669 10.2858C8.55973 10.2858 8.0666 9.77295 8.0666 9.14291C8.0666 8.51232 8.56026 8.00001 9.16669 8.00001C9.77364 8.00001 10.2668 8.51287 10.2668 9.14291C10.2668 9.7735 9.77311 10.2858 9.16669 10.2858Z'
      fill='currentcolor'
    />
  </svg>
);

const CelebraArrowRight = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      className='_stroke'
      d='M5 12H19M19 12L13.75 7M19 12L13.75 17'
      stroke='#181818'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);

const CelebraBag = ({ context = 'default', size = 16, ...props }: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 25'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M12 4.95856C13.933 4.95856 15.5 6.52556 15.5 8.45856H18C18.5523 8.45856 19 8.90627 19 9.45856V16.9586C19 18.8916 17.433 20.4586 15.5 20.4586H8.5C6.567 20.4586 5 18.8916 5 16.9586V9.45856C5 8.90627 5.44772 8.45856 6 8.45856H8.5C8.5 6.52556 10.067 4.95856 12 4.95856ZM6 16.9586C6 18.3393 7.11929 19.4586 8.5 19.4586H15.5C16.8807 19.4586 18 18.3393 18 16.9586V9.45856H6V16.9586ZM12 5.95856C10.6193 5.95856 9.5 7.07785 9.5 8.45856H14.5C14.5 7.07785 13.3807 5.95856 12 5.95856Z' />
  </svg>
);

const CelebraBagStar = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 25 25'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M5.46 3.73954L4.24667 5.40354C4.00635 5.73312 3.88618 5.89791 3.88897 6.03585C3.8914 6.15589 3.94612 6.26846 4.03803 6.34248C4.14364 6.42754 4.34391 6.42754 4.74444 6.42754H16.2556C16.6561 6.42754 16.8564 6.42754 16.962 6.34248C17.0539 6.26846 17.1086 6.15589 17.111 6.03585C17.1138 5.89791 16.9937 5.73312 16.7533 5.40354L15.54 3.73954M5.46 3.73954C5.59689 3.55181 5.66533 3.45794 5.75207 3.39024C5.8289 3.33028 5.9159 3.28554 6.00863 3.2583C6.11333 3.22754 6.22741 3.22754 6.45556 3.22754H14.5444C14.7726 3.22754 14.8867 3.22754 14.9914 3.2583C15.0841 3.28554 15.1711 3.33028 15.2479 3.39024C15.3347 3.45794 15.4031 3.55181 15.54 3.73954M5.46 3.73954L3.99778 5.74487C3.81309 5.99816 3.72074 6.12481 3.65517 6.26428C3.59698 6.38803 3.55454 6.51899 3.5289 6.65391C3.5 6.80595 3.5 6.96426 3.5 7.28087L3.5 16.6675C3.5 17.5636 3.5 18.0117 3.66955 18.3539C3.81868 18.655 4.05665 18.8997 4.34935 19.0531C4.6821 19.2275 5.1177 19.2275 5.98889 19.2275L10.5 19.2275M15.54 3.73954L17.0022 5.74487C17.1869 5.99816 17.2793 6.12481 17.3448 6.26428C17.403 6.38804 17.4455 6.51899 17.4711 6.65391C17.5 6.80595 17.5 6.96426 17.5 7.28087V10.7275M13.6111 9.62754C13.6111 10.4762 13.2833 11.2902 12.6999 11.8903C12.1164 12.4904 11.3251 12.8275 10.5 12.8275C9.67488 12.8275 8.88356 12.4904 8.30011 11.8903C7.71667 11.2902 7.38889 10.4762 7.38889 9.62754M15.6404 16.0774L13.0457 16.4354C12.7725 16.4731 12.6359 16.492 12.5727 16.555C12.5177 16.6098 12.4918 16.6851 12.5023 16.76C12.5143 16.846 12.6132 16.9369 12.811 17.1188L14.6878 18.8444C14.7463 18.8982 14.7756 18.9251 14.7944 18.9571C14.8112 18.9855 14.8219 19.0166 14.826 19.0488C14.8307 19.0851 14.8238 19.1231 14.81 19.1991L14.3671 21.6365C14.3204 21.8936 14.2971 22.0221 14.341 22.0984C14.3792 22.1648 14.447 22.2113 14.5257 22.2251C14.6161 22.2409 14.7384 22.1802 14.9829 22.0588L17.3025 20.9073C17.3747 20.8714 17.4109 20.8534 17.449 20.8464C17.4827 20.8401 17.5173 20.8401 17.551 20.8464C17.5891 20.8534 17.6253 20.8714 17.6975 20.9073L20.0171 22.0588C20.2616 22.1802 20.3839 22.2409 20.4743 22.2251C20.553 22.2113 20.6208 22.1648 20.659 22.0984C20.7029 22.0221 20.6796 21.8936 20.6329 21.6365L20.19 19.1991C20.1762 19.1231 20.1693 19.0851 20.174 19.0488C20.1781 19.0166 20.1888 18.9855 20.2056 18.9571C20.2244 18.9251 20.2537 18.8982 20.3122 18.8444L22.189 17.1188C22.3868 16.9369 22.4857 16.846 22.4977 16.76C22.5082 16.6851 22.4823 16.6098 22.4273 16.555C22.3641 16.492 22.2275 16.4731 21.9543 16.4354L19.3596 16.0774C19.2789 16.0663 19.2386 16.0607 19.2035 16.0453C19.1724 16.0316 19.1443 16.0124 19.121 15.9887C19.0946 15.9619 19.0766 15.9274 19.0405 15.8583L17.8805 13.64C17.7583 13.4062 17.6971 13.2893 17.6141 13.2519C17.5419 13.2194 17.4581 13.2194 17.3858 13.2519C17.3029 13.2893 17.2417 13.4062 17.1195 13.64L15.9595 15.8583C15.9234 15.9274 15.9054 15.9619 15.879 15.9887C15.8557 16.0124 15.8276 16.0316 15.7965 16.0453C15.7614 16.0607 15.7211 16.0663 15.6404 16.0774Z'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraBenefits = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 25 25'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M7.7 18.6971H9.78823C10.0605 18.6971 10.3311 18.7295 10.5951 18.7943L12.8015 19.3304C13.2803 19.4471 13.779 19.4584 14.2628 19.3645L16.7024 18.8898C17.3468 18.7643 17.9397 18.4557 18.4043 18.0037L20.1303 16.3247C20.6232 15.846 20.6232 15.0693 20.1303 14.5898C19.6865 14.1581 18.9838 14.1095 18.4817 14.4756L16.4701 15.9432C16.182 16.1538 15.8315 16.2672 15.4709 16.2672H13.5284L14.7649 16.2672C15.4618 16.2672 16.0263 15.718 16.0263 15.0401V14.7947C16.0263 14.2317 15.6325 13.7409 15.0713 13.6048L13.1629 13.1407C12.8523 13.0654 12.5342 13.0273 12.2145 13.0273C11.4427 13.0273 10.0455 13.6664 10.0455 13.6664L7.7 14.6472M17.9 7.82734C17.9 9.37374 16.6464 10.6273 15.1 10.6273C13.5536 10.6273 12.3 9.37374 12.3 7.82734C12.3 6.28095 13.5536 5.02734 15.1 5.02734C16.6464 5.02734 17.9 6.28095 17.9 7.82734ZM4.5 14.3073L4.5 18.9473C4.5 19.3954 4.5 19.6194 4.58719 19.7905C4.66389 19.9411 4.78628 20.0634 4.93681 20.1401C5.10794 20.2273 5.33196 20.2273 5.78 20.2273H6.42C6.86804 20.2273 7.09206 20.2273 7.26319 20.1401C7.41372 20.0635 7.53611 19.9411 7.61281 19.7905C7.7 19.6194 7.7 19.3954 7.7 18.9473V14.3073C7.7 13.8593 7.7 13.6353 7.61281 13.4642C7.53611 13.3136 7.41372 13.1912 7.26319 13.1145C7.09206 13.0273 6.86804 13.0273 6.42 13.0273L5.78 13.0273C5.33196 13.0273 5.10794 13.0273 4.93681 13.1145C4.78628 13.1912 4.66389 13.3136 4.58719 13.4642C4.5 13.6353 4.5 13.8593 4.5 14.3073Z'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      className='_stroke icon__nofill'
      d='M12.04 8.99985C12.0051 9.00612 11.9719 9.02206 11.9056 9.05395L9.77774 10.0775C9.55341 10.1855 9.44124 10.2394 9.3583 10.2253C9.28614 10.2131 9.22387 10.1717 9.18884 10.1127C9.14858 10.0449 9.17 9.93068 9.21285 9.70217L9.61909 7.53561C9.63175 7.46807 9.63809 7.4343 9.6338 7.40198C9.63001 7.37336 9.62017 7.34569 9.60484 7.3205C9.58752 7.29205 9.56069 7.26814 9.50702 7.22033L7.78533 5.68644C7.60387 5.52477 7.51314 5.44393 7.5021 5.36746C7.49249 5.30093 7.51622 5.23398 7.56668 5.18526C7.62468 5.12926 7.75 5.11251 8.00065 5.07899L10.3809 4.76076C10.4549 4.75087 10.4919 4.74592 10.5241 4.73221C10.5527 4.72007 10.5784 4.70298 10.5998 4.68189C10.624 4.65807 10.6405 4.62739 10.6736 4.56603L11.7377 2.59417C11.8499 2.38633 11.906 2.28241 11.9821 2.24921C12.0483 2.22032 12.1253 2.22032 12.1915 2.24921C12.2677 2.28241 12.3238 2.38633 12.4359 2.59417L14 5.22754'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const CelebraCalendar = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_1504_7899)'>
      <path d='M18 5H16V3.5C16 3.22 15.78 3 15.5 3C15.22 3 15 3.22 15 3.5V5H9V3.5C9 3.22 8.78 3 8.5 3C8.22 3 8 3.22 8 3.5V5H6C4.9 5 4 5.9 4 7V19C4 20.1 4.9 21 6 21H18C19.1 21 20 20.1 20 19V7C20 5.9 19.1 5 18 5ZM6 6H8V7.5C8 7.78 8.22 8 8.5 8C8.78 8 9 7.78 9 7.5V6H15V7.5C15 7.78 15.22 8 15.5 8C15.78 8 16 7.78 16 7.5V6H18C18.55 6 19 6.45 19 7V9H5V7C5 6.45 5.45 6 6 6ZM18 20H6C5.45 20 5 19.55 5 19V10H19V19C19 19.55 18.55 20 18 20Z' />
    </g>
  </svg>
);

export const CelebraCamera = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M4 9V6C4 4.89543 4.89543 4 6 4H9'
      stroke='#181818'
      strokeLinecap='round'
    />
    <path
      className='_stroke icon__nofill'
      d='M20 15L20 18C20 19.1046 19.1046 20 18 20L15 20'
      stroke='#181818'
      strokeLinecap='round'
    />
    <path
      className='_stroke icon__nofill'
      d='M15 4L18 4C19.1046 4 20 4.89543 20 6L20 9'
      stroke='#181818'
      strokeLinecap='round'
    />
    <path
      className='_stroke icon__nofill'
      d='M9 20L6 20C4.89543 20 4 19.1046 4 18L4 15'
      stroke='#181818'
      strokeLinecap='round'
    />
    <path
      className='_stroke icon__nofill'
      d='M7 10C7 9.44772 7.44772 9 8 9H8.38197C8.76074 9 9.107 8.786 9.27639 8.44721L9.72361 7.55279C9.893 7.214 10.2393 7 10.618 7H12H13.382C13.7607 7 14.107 7.214 14.2764 7.55279L14.7236 8.44721C14.893 8.786 15.2393 9 15.618 9H16C16.5523 9 17 9.44772 17 10V15C17 15.5523 16.5523 16 16 16H8C7.44772 16 7 15.5523 7 15V10Z'
      stroke='#181818'
    />
    <circle
      className='_stroke icon__nofill'
      cx='12'
      cy='12'
      r='2'
      stroke='#181818'
    />
  </svg>
);

const CelebraCard = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M21 10.2857H3M11.1 13.7143H6.6M3 8.74286L3 15.2571C3 16.2172 3 16.6973 3.19619 17.064C3.36876 17.3865 3.64413 17.6488 3.98282 17.8132C4.36786 18 4.87191 18 5.88 18L18.12 18C19.1281 18 19.6321 18 20.0172 17.8132C20.3559 17.6488 20.6312 17.3865 20.8038 17.064C21 16.6973 21 16.2172 21 15.2571V8.74286C21 7.78277 21 7.30272 20.8038 6.93602C20.6312 6.61345 20.3559 6.3512 20.0172 6.18685C19.6321 6 19.1281 6 18.12 6L5.88 6C4.87191 6 4.36786 6 3.98282 6.18685C3.64413 6.3512 3.36876 6.61345 3.19619 6.93602C3 7.30272 3 7.78277 3 8.74286Z'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraCardBlank = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M21 10.2857H3M3 8.74286L3 15.2571C3 16.2172 3 16.6973 3.19619 17.064C3.36876 17.3865 3.64413 17.6488 3.98282 17.8132C4.36786 18 4.87191 18 5.88 18L18.12 18C19.1281 18 19.6321 18 20.0172 17.8132C20.3559 17.6488 20.6312 17.3865 20.8038 17.064C21 16.6973 21 16.2172 21 15.2571V8.74286C21 7.78277 21 7.30272 20.8038 6.93602C20.6312 6.61345 20.3559 6.3512 20.0172 6.18685C19.6321 6 19.1281 6 18.12 6L5.88 6C4.87191 6 4.36786 6 3.98282 6.18685C3.64413 6.3512 3.36876 6.61345 3.19619 6.93602C3 7.30272 3 7.78277 3 8.74286Z'
      stroke='#4D4D4D'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraCardCheck = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 18 18'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M11.8 12.763L13.2 14.1111L16 11.4148M16 7.37037H2M16 8.71852V6.15704C16 5.402 16 5.02449 15.8474 4.7361C15.7132 4.48243 15.499 4.27619 15.2356 4.14694C14.9361 4 14.5441 4 13.76 4H4.24C3.45593 4 3.06389 4 2.76441 4.14694C2.50099 4.27619 2.28681 4.48243 2.15259 4.7361C2 5.02449 2 5.402 2 6.15704V11.28C2 12.035 2 12.4125 2.15259 12.7009C2.28681 12.9546 2.50099 13.1608 2.76441 13.2901C3.06389 13.437 3.45593 13.437 4.24 13.437H9'
      stroke='#EBB349'
      strokeWidth='0.777778'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraCardPlus = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M18.3 20V14.75M15.6 17.375H21M21 10.375H3M21 12.125V8.8C21 7.81991 21 7.32986 20.8038 6.95552C20.6312 6.62623 20.3559 6.35852 20.0172 6.19074C19.6321 6 19.1281 6 18.12 6H5.88C4.87191 6 4.36786 6 3.98282 6.19074C3.64413 6.35852 3.36876 6.62623 3.19619 6.95552C3 7.32986 3 7.81991 3 8.8V15.45C3 16.4301 3 16.9201 3.19619 17.2945C3.36876 17.6238 3.64413 17.8915 3.98282 18.0593C4.36786 18.25 4.87191 18.25 5.88 18.25H12'
      stroke='#747474'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraCardUpload = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M9.3 15.5L12 12.875M12 12.875L14.7 15.5M12 12.875V19M21 9.375H3M6.15 17.25H5.88C4.87191 17.25 4.36786 17.25 3.98282 17.0593C3.64413 16.8915 3.36876 16.6238 3.19619 16.2945C3 15.9201 3 15.4301 3 14.45V7.8C3 6.81991 3 6.32986 3.19619 5.95552C3.36876 5.62623 3.64413 5.35852 3.98282 5.19074C4.36786 5 4.87191 5 5.88 5H18.12C19.1281 5 19.6321 5 20.0172 5.19074C20.3559 5.35852 20.6312 5.62623 20.8038 5.95552C21 6.32986 21 6.81991 21 7.8V14.45C21 15.4301 21 15.9201 20.8038 16.2945C20.6312 16.6238 20.3559 16.8915 20.0172 17.0593C19.6321 17.25 19.1281 17.25 18.12 17.25H17.85'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraCategories = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect
      className='_stroke icon__nofill'
      x='5.5'
      y='5.5'
      width='5'
      height='5'
      rx='0.5'
      stroke='#181818'
    />
    <rect
      className='_stroke icon__nofill'
      x='5.5'
      y='13.5'
      width='5'
      height='5'
      rx='0.5'
      stroke='#181818'
    />
    <rect
      className='_stroke icon__nofill'
      x='13.5'
      y='5.5'
      width='5'
      height='5'
      rx='0.5'
      stroke='#181818'
    />
    <rect
      className='_stroke icon__nofill'
      x='13.5'
      y='13.5'
      width='5'
      height='5'
      rx='0.5'
      stroke='#181818'
    />
  </svg>
);

export const CelebraChevronDownThick = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M21.2501 7.75003C21.6058 8.17248 21.5517 8.80333 21.1293 9.15908L12.3942 16.5149C12.0142 16.8349 11.457 16.8275 11.0857 16.4974L2.8331 9.16181C2.42032 8.79489 2.38314 8.16282 2.75006 7.75003C3.11698 7.33725 3.74905 7.30007 4.16183 7.66699L11.1211 13.853C11.4923 14.183 12.0496 14.1905 12.4296 13.8705L19.841 7.62926C20.2635 7.27351 20.8943 7.32758 21.2501 7.75003Z'
    />
  </svg>
);

export const CelebraChevronDownThin = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M5 10L12 17L19 10'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const CelebraChevronLeftThick = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.25 21.2498C15.8275 21.6056 15.1967 21.5515 14.8409 21.129L7.48506 12.3939C7.16508 12.014 7.17253 11.4567 7.50256 11.0854L14.8382 2.83286C15.2051 2.42008 15.8372 2.3829 16.25 2.74981C16.6628 3.11673 16.6999 3.7488 16.333 4.16159L10.147 11.1208C9.817 11.4921 9.80955 12.0493 10.1295 12.4293L16.3707 19.8408C16.7265 20.2632 16.6724 20.8941 16.25 21.2498Z'
    />
  </svg>
);

export const CelebraChevronRightThin = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M9.5 19L16.5 12L9.5 5'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraCheckCircle = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M7 12.7037L10.0769 15.6667L17 9'
      stroke='#37A10A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <circle
      className='_stroke icon__nofill'
      cx='12'
      cy='12'
      r='9.5'
      stroke='#37A10A'
    />
  </svg>
);

const CelebraCircle = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 69 69'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g filter='url(#filter0_d_1174_5885)'>
      <rect
        className='_stroke icon__nofill'
        x='24.958'
        y='16.6836'
        width='20'
        height='20'
        rx='10'
      />
      <rect
        className='_stroke icon__nofill'
        x='25.458'
        y='17.1836'
        width='19'
        height='19'
        rx='9.5'
        stroke='#181818'
      />
    </g>
  </svg>
);

const CelebraCircleCheckFilled = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 68 68'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g filter='url(#filter0_d_1174_5877)'>
      <rect
        className='_stroke icon__fill'
        x='24'
        y='16'
        width='20'
        height='20'
        rx='10'
      />
      <path
        d='M28.4004 26.4444L31.8465 30L39.6004 22'
        stroke='white'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
  </svg>
);

const CelebraClock = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 17'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.24414 0.735352C12.4503 0.735574 15.8701 4.15609 15.8701 8.3623C15.8699 12.5683 12.4502 15.9881 8.24414 15.9883C4.03792 15.9883 0.61741 12.5685 0.617188 8.3623C0.617188 4.15595 4.03779 0.735352 8.24414 0.735352ZM8.24414 2.11035C4.79301 2.11035 1.99219 4.91118 1.99219 8.3623C1.99241 11.8132 4.79315 14.6143 8.24414 14.6143C11.6949 14.614 14.4959 11.8131 14.4961 8.3623C14.4961 4.91131 11.6951 2.11057 8.24414 2.11035Z'
      stroke='white'
      strokeWidth='0.258515'
    />
    <path
      d='M8.24609 4.16406C8.63185 4.16408 8.93359 4.4658 8.93359 4.85156V7.6748H11.0381C11.4238 7.67484 11.7256 7.97655 11.7256 8.3623C11.7254 8.74785 11.4237 9.04879 11.0381 9.04883H8.24609C7.86046 9.04883 7.55881 8.74788 7.55859 8.3623V4.85156C7.55859 4.46579 7.86032 4.16406 8.24609 4.16406Z'
      stroke='white'
      strokeWidth='0.258515'
    />
  </svg>
);

const CelebraClockProcess = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M12.5 21C17.1944 21 21 17.1944 21 12.5C21 7.80558 17.1944 4 12.5 4C7.80558 4 4 7.80558 4 12.5C4 17.1944 7.80558 21 12.5 21Z'
      stroke='#181818'
      strokeWidth='1.5'
      strokeMiterlimit='10'
    />
    <path
      className='_stroke icon__nofill'
      d='M19.3528 13.113C19.6922 13.113 19.9674 12.8379 19.9674 12.4985C19.9674 12.1591 19.6922 11.8839 19.3528 11.8839C19.0134 11.8839 18.7383 12.1591 18.7383 12.4985C18.7383 12.8379 19.0134 13.113 19.3528 13.113Z'
    />
    <path
      className='_stroke icon__nofill'
      d='M5.6917 13.113C6.0311 13.113 6.30624 12.8379 6.30624 12.4985C6.30624 12.1591 6.0311 11.8839 5.6917 11.8839C5.35229 11.8839 5.07715 12.1591 5.07715 12.4985C5.07715 12.8379 5.35229 13.113 5.6917 13.113Z'
    />
    <path
      className='_stroke icon__nofill'
      d='M12.5462 6.34689C12.8856 6.34689 13.1607 6.07175 13.1607 5.73234C13.1607 5.39294 12.8856 5.1178 12.5462 5.1178C12.2068 5.1178 11.9316 5.39294 11.9316 5.73234C11.9316 6.07175 12.2068 6.34689 12.5462 6.34689Z'
    />
    <path
      className='_stroke icon__nofill'
      d='M12.5462 20.1705C12.8856 20.1705 13.1607 19.8954 13.1607 19.556C13.1607 19.2165 12.8856 18.9414 12.5462 18.9414C12.2068 18.9414 11.9316 19.2165 11.9316 19.556C11.9316 19.8954 12.2068 20.1705 12.5462 20.1705Z'
    />
    <path
      className='_stroke icon__nofill'
      d='M12.5 8.83472V12.248C12.5 12.4109 12.5592 12.559 12.6777 12.6775L16.1058 16.1649'
      stroke='#181818'
      strokeWidth='1.5'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
  </svg>
);

const CelebraClockTime = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 17 17'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M8.625 0.117188C13.1253 0.117188 16.7734 3.76537 16.7734 8.26562C16.7734 12.7659 13.1253 16.4141 8.625 16.4141C4.12474 16.4141 0.476562 12.7659 0.476562 8.26562C0.476562 3.76537 4.12474 0.117188 8.625 0.117188ZM8.625 1.11719C4.67703 1.11719 1.47656 4.31765 1.47656 8.26562C1.47656 12.2136 4.67703 15.4141 8.625 15.4141C12.573 15.4141 15.7734 12.2136 15.7734 8.26562C15.7734 4.31765 12.573 1.11719 8.625 1.11719ZM8.83203 8.41504L12.3291 9.81445L12.1426 10.2793L11.957 10.7432L8.14648 9.21777L7.83203 9.09277V4.05469H8.83203V8.41504Z' />
  </svg>
);

const CelebraClose = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke'
      d='M2 2L14 14M14 2L2 14'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraCopy = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 9 9'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M1.23047 2.4884V7.79859C1.23047 8.11952 1.49063 8.37968 1.81156 8.37968H7.13077'
      stroke='#181818'
      strokeWidth='0.581091'
      strokeLinecap='round'
    />
    <rect
      className='_stroke icon__nofill'
      x='2.83984'
      y='0.346191'
      width='5.36391'
      height='6.42685'
      rx='0.581091'
      stroke='#181818'
      strokeWidth='0.581091'
    />
  </svg>
);

const CelebraCurrencyCircle = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 25'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M19.2712 7.46443C17.6365 5.21831 14.9886 3.75855 12 3.75855C7.03475 3.75855 3.00962 7.78798 3.00962 12.7585L3.00962 13.288M4.72879 18.0527C6.36348 20.2988 9.01145 21.7585 12 21.7585C16.9653 21.7585 20.9904 17.7291 20.9904 12.7585L20.9904 12.2291M1 11.6997L3.11539 13.8174L5.23077 11.6997M18.7692 13.8174L20.8846 11.6997L23 13.8174'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      className='_stroke icon__nofill'
      d='M9.5 14.8098C9.5 15.8011 10.2462 16.6047 11.1667 16.6047H12.7143C13.7005 16.6047 14.5 15.7437 14.5 14.6816C14.5 13.6195 13.7005 12.7585 12.7143 12.7585H11.2857C10.2995 12.7585 9.5 11.8976 9.5 10.8355C9.5 9.77338 10.2995 8.91239 11.2857 8.91239H12.8333C13.7538 8.91239 14.5 9.71598 14.5 10.7073M12 7.75854V8.91239M12 16.6047V17.7585'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraCurrencyCoin = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M8.0625 15C8.0625 16.4497 9.23775 17.625 10.6875 17.625H13.125C14.6783 17.625 15.9375 16.3658 15.9375 14.8125C15.9375 13.2592 14.6783 12 13.125 12H10.875C9.3217 12 8.0625 10.7408 8.0625 9.1875C8.0625 7.6342 9.3217 6.375 10.875 6.375H13.3125C14.7622 6.375 15.9375 7.55025 15.9375 9M12 4.6875V6.375M12 17.625V19.3125M23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12Z'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraDownloadLink = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M3.42969 9.09658V17.6815C3.42969 18.2507 3.6397 18.7966 4.01353 19.1991C4.38735 19.6016 4.89437 19.8277 5.42304 19.8277H18.5792C19.1079 19.8277 19.6149 19.6016 19.9887 19.1991C20.3625 18.7966 20.5725 18.2507 20.5725 17.6815V9.09658M15.5981 10.2144L12.0011 14.1728M12.0011 14.1728L8.25112 10.2144M12.0011 14.1728V3.42871'
      stroke='#181818'
      strokeWidth='0.9375'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const CelebraEdit = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 23 23'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M10.49 5.97968H7.39024C6.15022 5.97968 5.53021 5.97968 5.05658 6.221C4.63997 6.43328 4.30125 6.77199 4.08898 7.1886C3.84766 7.66223 3.84766 8.28224 3.84766 9.52226V15.7218C3.84766 16.9618 3.84766 17.5818 4.08898 18.0554C4.30125 18.472 4.63997 18.8108 5.05658 19.023C5.53021 19.2644 6.15022 19.2644 7.39024 19.2644H13.5898C14.8298 19.2644 15.4498 19.2644 15.9234 19.023C16.34 18.8108 16.6787 18.472 16.891 18.0554C17.1323 17.5818 17.1323 16.9618 17.1323 15.7218V12.622M8.27586 14.8361H9.51174C9.87277 14.8361 10.0533 14.8361 10.2232 14.7953C10.3738 14.7592 10.5178 14.6995 10.6498 14.6186C10.7988 14.5273 10.9264 14.3997 11.1817 14.1444L18.2394 7.08673C18.8508 6.47532 18.8508 5.48403 18.2394 4.87262C17.628 4.26121 16.6367 4.26121 16.0253 4.87262L8.9676 11.9303C8.71231 12.1856 8.58466 12.3132 8.49338 12.4622C8.41245 12.5942 8.3528 12.7382 8.31665 12.8888C8.27586 13.0587 8.27586 13.2392 8.27586 13.6003V14.8361Z'
      stroke='#181818'
      strokeWidth='0.928143'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraEye = ({ context = 'default', size = 16, ...props }: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.0759 12.0531C15.0759 13.7519 13.6982 15.1287 11.9994 15.1287C10.3006 15.1287 8.92383 13.7519 8.92383 12.0531C8.92383 10.3533 10.3006 8.97656 11.9994 8.97656C13.6982 8.97656 15.0759 10.3533 15.0759 12.0531Z'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      className='_stroke icon__nofill'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.9981 19.1575C15.7031 19.1575 19.092 16.4935 21 12.0529C19.092 7.61224 15.7031 4.94824 11.9981 4.94824H12.0019C8.29686 4.94824 4.908 7.61224 3 12.0529C4.908 16.4935 8.29686 19.1575 12.0019 19.1575H11.9981Z'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraEyeSlash = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 26 26'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M10.0451 15.545C9.36145 14.89 8.94531 13.9999 8.94531 13.0015C8.94531 11.0011 10.6241 9.38867 12.7072 9.38867C13.738 9.38867 14.6868 9.7892 15.3585 10.4442'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      className='_stroke icon__nofill'
      d='M16.4031 13.6416C16.1273 15.1136 14.9193 16.2753 13.3867 16.5423'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      className='_stroke icon__nofill'
      d='M6.3538 19.0875C4.46693 17.6656 2.86898 15.5888 1.71094 12.9996C2.88087 10.399 4.48952 8.31075 6.38828 6.8775C8.27516 5.44426 10.4521 4.66602 12.7088 4.66602C14.9785 4.66602 17.1543 5.45567 19.053 6.89918'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      className='_stroke icon__nofill'
      d='M21.5689 9.41016C22.3869 10.4531 23.1062 11.657 23.7114 13.0001C21.3727 18.2002 17.2399 21.3326 12.7136 21.3326C11.6875 21.3326 10.6757 21.1728 9.70312 20.8613'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      className='_stroke icon__nofill'
      d='M22.0866 4L3.33203 22'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraFileDownload = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M17.6765 12.4C17.6765 12.6761 17.9003 12.9 18.1765 12.9C18.4526 12.9 18.6765 12.6761 18.6765 12.4H18.1765H17.6765ZM12 20.5C12.2761 20.5 12.5 20.2761 12.5 20C12.5 19.7239 12.2761 19.5 12 19.5V20V20.5ZM5.26928 18.6896L5.71207 18.4573H5.71207L5.26928 18.6896ZM6.34896 19.7384L6.12716 20.1865H6.12716L6.34896 19.7384ZM16.8275 4.26158L16.6057 4.7097L16.8275 4.26158ZM17.9072 5.31042L17.4644 5.54267V5.54267L17.9072 5.31042ZM6.34896 4.26158L6.57077 4.7097L6.34896 4.26158ZM5.26928 5.31042L5.71207 5.54267H5.71207L5.26928 5.31042ZM14.4072 17.2414C14.2091 17.0489 13.8926 17.0535 13.7002 17.2516C13.5078 17.4497 13.5124 17.7662 13.7104 17.9586L14.0588 17.6L14.4072 17.2414ZM16.5294 20L16.181 20.3586C16.375 20.5471 16.6838 20.5471 16.8778 20.3586L16.5294 20ZM19.3484 17.9586C19.5465 17.7662 19.5511 17.4497 19.3586 17.2516C19.1662 17.0535 18.8497 17.0489 18.6516 17.2414L19 17.6L19.3484 17.9586ZM17.0294 15.2C17.0294 14.9239 16.8056 14.7 16.5294 14.7C16.2533 14.7 16.0294 14.9239 16.0294 15.2H16.5294H17.0294ZM8 7.5C7.72386 7.5 7.5 7.72386 7.5 8C7.5 8.27614 7.72386 8.5 8 8.5V8V7.5ZM14 8.5C14.2761 8.5 14.5 8.27614 14.5 8C14.5 7.72386 14.2761 7.5 14 7.5V8V8.5ZM8 10.5C7.72386 10.5 7.5 10.7239 7.5 11C7.5 11.2761 7.72386 11.5 8 11.5V11V10.5ZM12 11.5C12.2761 11.5 12.5 11.2761 12.5 11C12.5 10.7239 12.2761 10.5 12 10.5V11V11.5ZM8 13.5C7.72386 13.5 7.5 13.7239 7.5 14C7.5 14.2761 7.72386 14.5 8 14.5V14V13.5ZM10 14.5C10.2761 14.5 10.5 14.2761 10.5 14C10.5 13.7239 10.2761 13.5 10 13.5V14V14.5ZM8.95294 4V4.5H14.2235V4V3.5H8.95294V4ZM5 16.16H5.5V7.84H5H4.5V16.16H5ZM18.1765 7.84H17.6765V12.4H18.1765H18.6765V7.84H18.1765ZM12 20V19.5H8.95282V20V20.5H12V20ZM5 16.16H4.5C4.5 16.8236 4.49959 17.3522 4.53542 17.7782C4.57178 18.2105 4.64806 18.5816 4.82649 18.9218L5.26928 18.6896L5.71207 18.4573C5.62122 18.2841 5.56286 18.0625 5.5319 17.6944C5.50041 17.32 5.5 16.8406 5.5 16.16H5ZM8.95282 20V19.5C8.25302 19.5 7.75738 19.4996 7.3698 19.4689C6.98764 19.4385 6.75407 19.381 6.57077 19.2903L6.34896 19.7384L6.12716 20.1865C6.47234 20.3574 6.84891 20.4307 7.29067 20.4657C7.727 20.5004 8.26905 20.5 8.95282 20.5V20ZM5.26928 18.6896L4.82649 18.9218C5.11328 19.4686 5.56944 19.9105 6.12716 20.1865L6.34896 19.7384L6.57077 19.2903C6.19875 19.1062 5.899 18.8137 5.71207 18.4573L5.26928 18.6896ZM14.2235 4V4.5C14.9234 4.5 15.419 4.50037 15.8066 4.53113C16.1888 4.56146 16.4224 4.61897 16.6057 4.7097L16.8275 4.26158L17.0493 3.81347C16.7041 3.64262 16.3275 3.56933 15.8858 3.53427C15.4494 3.49963 14.9073 3.5 14.2235 3.5V4ZM18.1765 7.84H18.6765C18.6765 7.17643 18.6769 6.6478 18.6411 6.22178C18.6047 5.78948 18.5284 5.41837 18.35 5.07818L17.9072 5.31042L17.4644 5.54267C17.5552 5.71587 17.6136 5.93748 17.6446 6.30559C17.6761 6.67998 17.6765 7.15945 17.6765 7.84H18.1765ZM16.8275 4.26158L16.6057 4.7097C16.9777 4.89383 17.2775 5.18627 17.4644 5.54267L17.9072 5.31042L18.35 5.07818C18.0632 4.5314 17.607 4.08953 17.0493 3.81347L16.8275 4.26158ZM8.95294 4V3.5C8.26913 3.5 7.72705 3.49963 7.2907 3.53427C6.84893 3.56933 6.47235 3.64262 6.12716 3.81347L6.34896 4.26158L6.57077 4.7097C6.75407 4.61897 6.98765 4.56146 7.36982 4.53113C7.75743 4.50037 8.25309 4.5 8.95294 4.5V4ZM5 7.84H5.5C5.5 7.15945 5.50041 6.67998 5.5319 6.30559C5.56286 5.93748 5.62122 5.71587 5.71207 5.54267L5.26928 5.31042L4.82649 5.07818C4.64806 5.41837 4.57178 5.78948 4.53542 6.22178C4.49959 6.6478 4.5 7.17643 4.5 7.84H5ZM6.34896 4.26158L6.12716 3.81347C5.56944 4.08953 5.11328 4.5314 4.82649 5.07818L5.26928 5.31042L5.71207 5.54267C5.899 5.18627 6.19875 4.89383 6.57077 4.7097L6.34896 4.26158ZM14.0588 17.6L13.7104 17.9586L16.181 20.3586L16.5294 20L16.8778 19.6414L14.4072 17.2414L14.0588 17.6ZM16.5294 20L16.8778 20.3586L19.3484 17.9586L19 17.6L18.6516 17.2414L16.181 19.6414L16.5294 20ZM16.5294 15.2H16.0294V20H16.5294H17.0294V15.2H16.5294ZM8 8V8.5H14V8V7.5H8V8ZM8 11V11.5H12V11V10.5H8V11ZM8 14V14.5H10V14V13.5H8V14Z' />
  </svg>
);

const CelebraFileLoading = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M18.2353 10.4V7.84C18.2353 6.49587 18.2353 5.82381 17.9852 5.31042C17.7653 4.85883 17.4143 4.49168 16.9827 4.26158C16.4919 4 15.8495 4 14.5647 4H9.67059C8.38576 4 7.74335 4 7.25261 4.26158C6.82094 4.49168 6.46999 4.85883 6.25004 5.31042C6 5.82381 6 6.49587 6 7.84V16.16C6 17.5041 6 18.1762 6.25004 18.6896C6.46999 19.1412 6.82094 19.5083 7.25261 19.7384C7.74335 20 8.38576 20 9.67059 20H12.1176'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <circle
      className='_stroke icon__nofill'
      cx='18'
      cy='17'
      r='3.5'
      stroke='#181818'
    />
    <path
      className='_stroke icon__nofill'
      d='M18 15V17L16.5 18'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraFilter = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 25'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M21 8.5H10.95C10.7184 7.35888 9.70948 6.5 8.5 6.5C7.29052 6.5 6.28164 7.35888 6.05001 8.5H3V9.5H6.05001C6.28164 10.6411 7.29052 11.5 8.5 11.5C9.70948 11.5 10.7184 10.6411 10.95 9.5H21V8.5Z' />
    <path d='M21 15.5H17.95C17.7184 14.3589 16.7095 13.5 15.5 13.5C14.2905 13.5 13.2816 14.3589 13.05 15.5H3V16.5H13.05C13.2816 17.6411 14.2905 18.5 15.5 18.5C16.7095 18.5 17.7184 17.6411 17.95 16.5H21V15.5Z' />
  </svg>
);

const CelebraGallery = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M19 9.66667L13.9845 13.2492C13.8321 13.358 13.7559 13.4125 13.6743 13.4289C13.6024 13.4433 13.5278 13.4372 13.4593 13.4111C13.3815 13.3815 13.3153 13.3153 13.1828 13.1828L10.8172 10.8172C10.6847 10.6847 10.6185 10.6185 10.5407 10.5889C10.4722 10.5628 10.3976 10.5567 10.3257 10.5711C10.2441 10.5875 10.1679 10.642 10.0155 10.7508L5 14.3333M8.73333 19H15.2667C16.5735 19 17.2269 19 17.726 18.7457C18.165 18.522 18.522 18.165 18.7457 17.726C19 17.2269 19 16.5735 19 15.2667V8.73333C19 7.42654 19 6.77315 18.7457 6.27402C18.522 5.83498 18.165 5.47802 17.726 5.25432C17.2269 5 16.5735 5 15.2667 5H8.73333C7.42654 5 6.77315 5 6.27402 5.25432C5.83498 5.47802 5.47802 5.83498 5.25432 6.27402C5 6.77315 5 7.42654 5 8.73333V15.2667C5 16.5735 5 17.2269 5.25432 17.726C5.47802 18.165 5.83498 18.522 6.27402 18.7457C6.77315 19 7.42654 19 8.73333 19Z'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const CelebraGift = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M12 7.2V20M12 7.2H9.17143C8.75466 7.2 8.35496 7.03143 8.06026 6.73137C7.76556 6.43131 7.6 6.02435 7.6 5.6C7.6 5.17565 7.76556 4.76869 8.06026 4.46863C8.35496 4.16857 8.75466 4 9.17143 4C11.3714 4 12 7.2 12 7.2ZM12 7.2H14.8286C15.2453 7.2 15.645 7.03143 15.9397 6.73137C16.2344 6.43131 16.4 6.02435 16.4 5.6C16.4 5.17565 16.2344 4.76869 15.9397 4.46863C15.645 4.16857 15.2453 4 14.8286 4C12.6286 4 12 7.2 12 7.2ZM18.4 11.2V17.44C18.4 18.3361 18.4 18.7841 18.2256 19.1264C18.0722 19.4274 17.8274 19.6722 17.5264 19.8256C17.1841 20 16.7361 20 15.84 20L8.16 20C7.26392 20 6.81587 20 6.47362 19.8256C6.17256 19.6722 5.92779 19.4274 5.77439 19.1264C5.6 18.7841 5.6 18.3361 5.6 17.44V11.2M4 8.48L4 9.92C4 10.368 4 10.5921 4.08719 10.7632C4.16389 10.9137 4.28628 11.0361 4.43681 11.1128C4.60794 11.2 4.83196 11.2 5.28 11.2L18.72 11.2C19.168 11.2 19.3921 11.2 19.5632 11.1128C19.7137 11.0361 19.8361 10.9137 19.9128 10.7632C20 10.5921 20 10.368 20 9.92V8.48C20 8.03196 20 7.80794 19.9128 7.63681C19.8361 7.48628 19.7137 7.36389 19.5632 7.2872C19.3921 7.2 19.168 7.2 18.72 7.2L5.28 7.2C4.83196 7.2 4.60794 7.2 4.43681 7.28719C4.28628 7.36389 4.16389 7.48628 4.08719 7.63681C4 7.80794 4 8.03196 4 8.48Z'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const CelebraGiftPlus = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 18 19'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M14.0664 13.4141C14.3325 13.4142 14.5479 13.6304 14.5479 13.8965V15.2852H15.9131C16.1793 15.2852 16.3954 15.5005 16.3955 15.7666C16.3955 16.0328 16.1793 16.249 15.9131 16.249H14.5479V17.6367C14.5479 17.9028 14.3325 18.119 14.0664 18.1191C13.8002 18.1191 13.584 17.9029 13.584 17.6367V16.249H12.2188C11.9525 16.249 11.7363 16.0328 11.7363 15.7666C11.7364 15.5005 11.9526 15.2852 12.2188 15.2852H13.584V13.8965C13.584 13.6303 13.8002 13.4141 14.0664 13.4141ZM11.7188 0.639648C12.2036 0.688602 12.658 0.906659 13.0029 1.25781C13.3967 1.65871 13.6162 2.20037 13.6162 2.7627L13.6084 2.94336C13.586 3.20841 13.5133 3.46473 13.3984 3.70117H15.2461C15.4514 3.70117 15.6409 3.70099 15.7988 3.71387C15.9642 3.72738 16.147 3.75883 16.3271 3.85059C16.5837 3.98146 16.793 4.19043 16.9238 4.44727L16.9814 4.58301C17.0294 4.7181 17.0495 4.8514 17.0596 4.97461C17.0725 5.13258 17.0723 5.32291 17.0723 5.52832V6.91016C17.0723 7.11556 17.0725 7.3059 17.0596 7.46387C17.0461 7.62809 17.0158 7.81068 16.9238 7.99121C16.793 8.24806 16.5838 8.45701 16.3271 8.58789C16.147 8.67965 15.9642 8.71109 15.7988 8.72461C15.7185 8.73116 15.63 8.73315 15.5361 8.73438V12.2148C15.5361 12.301 15.4896 12.3808 15.415 12.4238C15.3405 12.4667 15.2483 12.4669 15.1738 12.4238C14.9663 12.3038 14.7451 12.2055 14.5127 12.1348C14.4113 12.1038 14.3418 12.0103 14.3418 11.9043V8.7373H9.3916V15.9912H10.252C10.3642 15.9912 10.4611 16.0693 10.4863 16.1787C10.5397 16.4098 10.6182 16.6312 10.7188 16.8398C10.7547 16.9145 10.75 17.0021 10.7061 17.0723C10.662 17.1425 10.5849 17.1855 10.502 17.1855H5.10742C4.68757 17.1855 4.336 17.1865 4.0498 17.1631C3.75642 17.1391 3.47913 17.0868 3.2168 16.9531C2.8655 16.7741 2.57124 16.5014 2.36621 16.167L2.28418 16.0205C2.15044 15.7579 2.0991 15.4801 2.0752 15.1875C2.06354 15.0447 2.05759 14.8857 2.05469 14.71L2.05176 14.1309V8.73438C1.95785 8.73316 1.8694 8.73117 1.78906 8.72461C1.62339 8.71107 1.44157 8.67948 1.26172 8.58789C1.00485 8.45701 0.795924 8.24794 0.665039 7.99121C0.573429 7.81138 0.541874 7.62937 0.528321 7.46387C0.521877 7.38496 0.519095 7.29798 0.517578 7.20508L0.515625 6.91016V5.52832C0.515625 5.32291 0.51542 5.13258 0.528321 4.97461C0.541867 4.809 0.573396 4.62716 0.665039 4.44727C0.795937 4.1904 1.00482 3.98148 1.26172 3.85059C1.44162 3.75895 1.62341 3.72741 1.78906 3.71387C1.94693 3.70098 2.13655 3.70117 2.3418 3.70117H4.19043C4.07573 3.46456 4.00273 3.20838 3.98047 2.94336L3.97266 2.7627C3.97267 2.20036 4.19219 1.65872 4.58594 1.25781C4.97982 0.856941 5.5162 0.628994 6.07812 0.628906L6.33301 0.640625C7.57512 0.755984 8.33481 1.70364 8.75391 2.47949C8.76817 2.50591 8.78031 2.53324 8.79395 2.55957C8.80768 2.53311 8.82062 2.50604 8.83496 2.47949C9.28193 1.65206 10.1156 0.62897 11.5098 0.628906L11.7188 0.639648ZM3.24707 14.1309L3.24902 14.6914C3.2514 14.8479 3.2564 14.9779 3.26563 15.0908C3.28349 15.3094 3.3158 15.4122 3.34961 15.4785C3.43965 15.6551 3.5833 15.7987 3.75977 15.8887L3.81738 15.9131C3.88411 15.9369 3.98245 15.9582 4.14648 15.9717C4.37281 15.9902 4.66793 15.9912 5.10742 15.9912H8.19629V8.7373H3.24707V14.1309ZM2.3418 4.89648C2.11651 4.89648 1.98455 4.89633 1.88672 4.9043C1.79705 4.91163 1.78844 4.9228 1.80371 4.91504C1.77181 4.93134 1.74588 4.95725 1.72949 4.98926C1.73725 4.97399 1.72608 4.98259 1.71875 5.07227C1.71078 5.17016 1.71094 5.30269 1.71094 5.52832V6.91016C1.71094 7.13596 1.71076 7.26832 1.71875 7.36621C1.72608 7.45588 1.73725 7.46449 1.72949 7.44922C1.74598 7.48134 1.77199 7.50725 1.80371 7.52344C1.78652 7.5147 1.79359 7.52559 1.88672 7.5332C1.98493 7.5412 2.1181 7.54199 2.3418 7.54199H8.19629V4.89648H2.3418ZM9.3916 7.54199H15.2461C15.4704 7.54199 15.6039 7.54123 15.7021 7.5332C15.7939 7.52569 15.8007 7.51506 15.7842 7.52344L15.8281 7.49121C15.8408 7.47865 15.8515 7.46463 15.8594 7.44922C15.8506 7.46641 15.8615 7.45934 15.8691 7.36621C15.8772 7.26793 15.8779 7.13435 15.8779 6.91016V5.52832C15.8779 5.30431 15.8771 5.17054 15.8691 5.07227C15.8615 4.97912 15.8506 4.97206 15.8594 4.98926C15.8515 4.97384 15.8408 4.95983 15.8281 4.94727L15.7842 4.91504C15.7899 4.91795 15.7915 4.91728 15.7822 4.91504C15.7708 4.91229 15.7464 4.90792 15.7021 4.9043C15.6043 4.8963 15.472 4.89648 15.2461 4.89648H9.3916V7.54199ZM6.07812 1.82422C5.83975 1.8243 5.60901 1.92015 5.4375 2.09473C5.26543 2.26996 5.167 2.51025 5.16699 2.7627C5.16699 3.01515 5.26542 3.25541 5.4375 3.43066C5.60901 3.60526 5.83973 3.70109 6.07812 3.70117H7.99414C7.91886 3.49704 7.82401 3.26968 7.70312 3.0459C7.32115 2.33897 6.79706 1.82422 6.07812 1.82422ZM11.5098 1.82422C10.7911 1.82427 10.2678 2.33896 9.88574 3.0459C9.76479 3.26981 9.66928 3.49715 9.59375 3.70117H11.5098C11.7481 3.70117 11.9787 3.60532 12.1504 3.43066C12.3225 3.25541 12.4209 3.01515 12.4209 2.7627C12.4209 2.51025 12.3225 2.26996 12.1504 2.09473C11.9787 1.92008 11.748 1.82422 11.5098 1.82422Z' />
  </svg>
);

const CelebraHome = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M15.4033 20.4925V16.8329C15.4033 16.0005 14.7184 15.3331 13.8813 15.3331H11.1187C10.274 15.3331 9.59665 16.008 9.59665 16.8329V20.4925C9.59665 20.7025 9.42922 20.8675 9.21613 20.8675H8.04414C6.36225 20.8675 5 19.5251 5 17.8678V10.0087C5 9.54376 5.2207 9.10131 5.59361 8.81634L11.5601 4.30934C12.1081 3.89689 12.8691 3.89689 13.4094 4.30934L19.3988 8.82384C19.7793 9.10881 20 9.55126 20 10.0162V17.8753C20 19.5326 18.6377 20.875 16.9559 20.875H15.7839C15.5708 20.875 15.4033 20.71 15.4033 20.5V20.4925Z'
      stroke='#181818'
      strokeWidth='1.5'
      strokeMiterlimit='10'
    />
    <path
      className='_stroke icon__nofill'
      d='M11.5625 20.875L13.4375 20.875'
      stroke='#181818'
      strokeWidth='1.5'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
  </svg>
);

export const CelebraInformation = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 13 13'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M6.42479 5.48475V10.1121M6.42479 3.17109V4.32792M12.209 6.64159C12.209 9.83609 9.61929 12.4257 6.42479 12.4257C3.23028 12.4257 0.640625 9.83609 0.640625 6.64159C0.640625 3.44708 3.23028 0.857422 6.42479 0.857422C9.61929 0.857422 12.209 3.44708 12.209 6.64159Z'
      stroke='#181818'
      strokeWidth='0.749799'
    />
  </svg>
);

const CelebraMail = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 25'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.2002 5.18823C20.0494 5.1883 20.7932 5.61417 21.2529 6.25171C21.5662 6.68825 21.75 7.22696 21.75 7.80542V18.071C21.75 19.4915 20.6326 20.6881 19.2002 20.6882H4.7998C3.36735 20.6881 2.25 19.4915 2.25 18.071V7.80542C2.25 7.23469 2.42819 6.70331 2.73438 6.26929L2.74805 6.25073C2.98094 5.92325 3.28866 5.65622 3.64551 5.47144C3.95797 5.30966 4.30031 5.2149 4.65039 5.19312L4.80078 5.18823H19.2002ZM19.8154 8.71851L14.0352 15.0798C13.7774 15.3634 13.4627 15.5898 13.1123 15.7449C12.7619 15.8999 12.3832 15.9802 12 15.9802C11.6168 15.9802 11.2381 15.8999 10.8877 15.7449C10.5373 15.5898 10.2226 15.3634 9.96484 15.0798L4.18457 8.71851L3.75 8.23901V18.071C3.75 18.7175 4.24837 19.1881 4.7998 19.1882H19.2002C19.7516 19.1881 20.25 18.7175 20.25 18.071V8.23901L19.8154 8.71851ZM4.74805 7.1062L11.0752 14.071C11.1923 14.1999 11.3349 14.3033 11.4941 14.3738C11.6534 14.4443 11.8258 14.4802 12 14.4802C12.1742 14.4802 12.3466 14.4443 12.5059 14.3738C12.6651 14.3033 12.8077 14.1999 12.9248 14.071L19.252 7.1062L19.6318 6.68823H4.36816L4.74805 7.1062Z'
      stroke='white'
      strokeWidth='0.5'
    />
  </svg>
);

const CelebraMapPin = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M11.5717 22.8682C11.5717 22.8682 11.5721 22.8685 12 22.2165L12.4279 22.8685C12.1688 23.044 11.8308 23.0437 11.5717 22.8682Z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 6.22431C9.86976 6.22431 8.14286 7.97856 8.14286 10.1425C8.14286 12.3065 9.86976 14.0608 12 14.0608C14.1302 14.0608 15.8571 12.3065 15.8571 10.1425C15.8571 7.97856 14.1302 6.22431 12 6.22431ZM9.68571 10.1425C9.68571 8.84415 10.7219 7.7916 12 7.7916C13.2781 7.7916 14.3143 8.84415 14.3143 10.1425C14.3143 11.4409 13.2781 12.4935 12 12.4935C10.7219 12.4935 9.68571 11.4409 9.68571 10.1425Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.5717 22.8682L12 22.2165C12.4279 22.8685 12.429 22.8678 12.429 22.8678L12.4308 22.8666L12.4366 22.8626L12.457 22.8486C12.4745 22.8365 12.4995 22.8191 12.5316 22.7966C12.5958 22.7514 12.6884 22.6854 12.8052 22.5996C13.0388 22.4283 13.37 22.1778 13.7663 21.8572C14.5575 21.2172 15.6146 20.2928 16.6743 19.1565C18.7621 16.9178 21 13.7082 21 10.1425C21 7.71779 20.0518 5.39235 18.364 3.67779C16.6761 1.96323 14.3869 1 12 1C9.61305 1 7.32387 1.96323 5.63604 3.67779C3.94821 5.39235 3 7.71779 3 10.1425C3 13.7082 5.23786 16.9178 7.32569 19.1565C8.38539 20.2928 9.44246 21.2172 10.2337 21.8572C10.63 22.1778 10.9612 22.4283 11.1948 22.5996C11.3116 22.6854 11.4042 22.7514 11.4684 22.7966C11.5005 22.8191 11.5255 22.8365 11.543 22.8486L11.5634 22.8626L11.5692 22.8666L11.5717 22.8682ZM6.727 4.78603C8.12549 3.3654 10.0222 2.56729 12 2.56729C13.9778 2.56729 15.8745 3.3654 17.273 4.78603C18.6715 6.20667 19.4571 8.13346 19.4571 10.1425C19.4571 13.0782 17.5807 15.9057 15.5543 18.0786C14.5568 19.1481 13.5567 20.0232 12.8052 20.6312C12.4834 20.8915 12.2083 21.1019 12 21.2566C11.7917 21.1019 11.5166 20.8915 11.1948 20.6312C10.4433 20.0232 9.44319 19.1481 8.44574 18.0786C6.41928 15.9057 4.54286 13.0782 4.54286 10.1425C4.54286 8.13346 5.32852 6.20667 6.727 4.78603Z'
    />
  </svg>
);

const CelebraMessage = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_1977_13398)'>
      <path d='M16.96 4H7.04C5.36 4 4 5.36 4 7.04V16.96C4 18.64 5.36 20 7.04 20H14.5C14.64 20 14.77 19.94 14.87 19.83L19.83 14.87C19.93 14.77 19.99 14.63 19.99 14.5V7.04C19.99 5.36 18.63 4 16.95 4H16.96ZM14.5 18.79V16.18C14.5 15.25 15.35 14.5 16.4 14.5H18.79L14.5 18.79ZM16.4 13.5C14.8 13.5 13.5 14.7 13.5 16.18V19H7.04C5.92 19 5 18.09 5 16.96V7.04C5 5.92 5.91 5 7.04 5H16.96C18.08 5 19 5.91 19 7.04V13.5H16.4Z' />
      <path d='M16 9H8C7.72 9 7.5 8.78 7.5 8.5C7.5 8.22 7.72 8 8 8H16C16.28 8 16.5 8.22 16.5 8.5C16.5 8.78 16.28 9 16 9Z' />
      <path d='M16 12H8C7.72 12 7.5 11.78 7.5 11.5C7.5 11.22 7.72 11 8 11H16C16.28 11 16.5 11.22 16.5 11.5C16.5 11.78 16.28 12 16 12Z' />
      <path d='M12 15H8C7.72 15 7.5 14.78 7.5 14.5C7.5 14.22 7.72 14 8 14H12C12.28 14 12.5 14.22 12.5 14.5C12.5 14.78 12.28 15 12 15Z' />
    </g>
  </svg>
);

const CelebraMinus = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 22 22'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M4 12H20'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraLocation = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M6.4 13.8291C4.91891 14.4825 4 15.3929 4 16.4C4 18.3882 7.58172 20 12 20C16.4183 20 20 18.3882 20 16.4C20 15.3929 19.0811 14.4825 17.6 13.8291M16.8 8.8C16.8 12.051 14 14 12 16.4C10 14 7.2 12.051 7.2 8.8C7.2 6.14903 9.34903 4 12 4C14.651 4 16.8 6.14903 16.8 8.8ZM12.8 8.8C12.8 9.24183 12.4418 9.6 12 9.6C11.5582 9.6 11.2 9.24183 11.2 8.8C11.2 8.35817 11.5582 8 12 8C12.4418 8 12.8 8.35817 12.8 8.8Z'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraLockClosed = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 14 15'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M3.35742 6.86079V4.64724C3.35742 2.60974 4.99263 0.958008 7.00977 0.958008C9.0269 0.958008 10.6621 2.60974 10.6621 4.64724V6.88202M10.6621 6.88202C10.3178 6.86079 9.89323 6.86079 9.34727 6.86079H4.67227C3.44496 6.86079 2.83131 6.86079 2.36254 7.10205C1.9502 7.31427 1.61496 7.6529 1.40486 8.0694C1.16602 8.5429 1.16602 9.16275 1.16602 10.4025V10.6976C1.16602 11.9373 1.16602 12.5571 1.40486 13.0306C1.61496 13.4471 1.9502 13.7858 2.36254 13.998C2.83131 14.2393 3.44496 14.2393 4.67227 14.2393H9.34727C10.5746 14.2393 11.1882 14.2393 11.657 13.998C12.0693 13.7858 12.4046 13.4471 12.6147 13.0306C12.8535 12.5571 12.8535 11.9373 12.8535 10.6976V10.4025C12.8535 9.16275 12.8535 8.5429 12.6147 8.0694C12.4046 7.6529 12.0693 7.31427 11.657 7.10205C11.3967 6.96811 11.0919 6.90853 10.6621 6.88202Z'
      stroke='#4D4D4D'
      strokeWidth='1.0625'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraLockOpen = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 14 15'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M10.4961 4.64724C10.4961 2.60974 8.86088 0.958008 6.84375 0.958008C4.82662 0.958008 3.19141 2.60974 3.19141 4.64724V6.86079M4.50625 14.2393H9.18125C10.4086 14.2393 11.0222 14.2393 11.491 13.998C11.9033 13.7858 12.2386 13.4471 12.4487 13.0306C12.6875 12.5571 12.6875 11.9373 12.6875 10.6976V10.4025C12.6875 9.16275 12.6875 8.5429 12.4487 8.0694C12.2386 7.6529 11.9033 7.31427 11.491 7.10205C11.0222 6.86079 10.4086 6.86079 9.18125 6.86079H4.50625C3.27895 6.86079 2.6653 6.86079 2.19653 7.10205C1.78419 7.31427 1.44895 7.6529 1.23885 8.0694C1 8.5429 1 9.16275 1 10.4025V10.6976C1 11.9373 1 12.5571 1.23885 13.0306C1.44895 13.4471 1.78419 13.7858 2.19653 13.998C2.6653 14.2393 3.27895 14.2393 4.50625 14.2393Z'
      stroke='#4D4D4D'
      strokeWidth='1.0625'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const CelebraPictureSearch = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.85373 3.94531L11.6829 3.94531C11.9513 3.94531 12.169 4.16295 12.169 4.43142C12.169 4.6999 11.9513 4.91754 11.6829 4.91754H7.875C7.18636 4.91754 6.69911 4.91791 6.3182 4.94903C5.94296 4.97969 5.71392 5.03775 5.53391 5.12947C5.16804 5.31589 4.87057 5.61335 4.68415 5.97922C4.59243 6.15923 4.53438 6.38828 4.50372 6.76351C4.4726 7.14443 4.47222 7.63167 4.47222 8.32031V15.1259C4.47222 15.8145 4.4726 16.3018 4.50372 16.6827C4.53438 17.0579 4.59243 17.2869 4.68415 17.467C4.87057 17.8328 5.16804 18.1303 5.53391 18.3167C5.6077 18.3543 5.68972 18.3862 5.78668 18.413C5.8377 18.216 5.96542 18.0664 6.05421 17.9703C6.16725 17.848 6.325 17.7046 6.50414 17.5417L13.3853 11.2862C13.5202 11.1635 13.6409 11.0537 13.749 10.9695C13.8651 10.879 13.9938 10.7957 14.1517 10.7444C14.3854 10.6685 14.6359 10.6606 14.874 10.7216C15.0348 10.7628 15.1685 10.8379 15.2901 10.9209C15.4032 10.9981 15.5306 11.1 15.673 11.214L17.952 13.0372C17.9656 13.048 17.979 13.0588 17.9922 13.0693C18.2597 13.2832 18.4548 13.4391 18.6061 13.6318C18.7954 13.873 18.9297 14.1526 18.9998 14.451C19.0558 14.6895 19.0557 14.9393 19.0556 15.2817C19.0556 15.2987 19.0556 15.3158 19.0556 15.3333V15.3515C19.0556 15.4928 19.0556 15.6269 19.0552 15.7543C19.0554 15.7608 19.0556 15.7674 19.0556 15.774C19.0556 15.8013 19.0556 15.8283 19.0556 15.8548C19.0557 16.5306 19.0558 16.9672 18.9562 17.3391C18.8382 17.7794 18.6213 18.1776 18.3304 18.5088C18.2389 18.6131 18.14 18.7107 18.0345 18.8009C17.7092 19.0791 17.3214 19.2869 16.8938 19.4015C16.5219 19.5011 16.0853 19.501 15.4095 19.5009C15.3829 19.5009 15.356 19.5009 15.3287 19.5009H14.9367C14.9266 19.5009 14.9164 19.5009 14.9061 19.5009H7.85372C7.84186 19.5009 7.83004 19.5009 7.81827 19.5009H7.26155C7.04355 19.5009 6.849 19.5009 6.69127 19.4903C6.52879 19.4852 6.37843 19.4775 6.23903 19.4661C5.80367 19.4306 5.43244 19.3562 5.09253 19.183C4.54372 18.9033 4.09753 18.4571 3.8179 17.9083C3.6447 17.5684 3.5703 17.1972 3.53473 16.7618C3.49999 16.3367 3.5 15.8097 3.5 15.1471V8.29904C3.5 7.63645 3.49999 7.10949 3.53473 6.68434C3.5703 6.24898 3.6447 5.87775 3.8179 5.53784C4.09753 4.98903 4.54372 4.54284 5.09253 4.26321C5.43244 4.09002 5.80367 4.01561 6.23903 3.98004C6.66418 3.94531 7.19114 3.94531 7.85373 3.94531ZM17.638 17.8225C17.7554 17.6805 17.8529 17.5213 17.9266 17.349C17.9943 17.1908 18.0373 16.9914 18.06 16.6682C18.0831 16.3404 18.0833 15.9231 18.0833 15.3333C18.0833 14.9179 18.0803 14.7882 18.0533 14.6732C18.0156 14.5125 17.9432 14.362 17.8413 14.2321C17.7684 14.1392 17.669 14.0558 17.3447 13.7963L15.0784 11.9833C14.9193 11.8561 14.8209 11.7778 14.7419 11.7238C14.668 11.6734 14.6406 11.6655 14.6326 11.6634C14.5731 11.6481 14.5104 11.6501 14.452 11.6691C14.4441 11.6717 14.4173 11.6813 14.3467 11.7363C14.2712 11.7951 14.178 11.8795 14.0273 12.0165L7.17399 18.2467C7.04661 18.3625 6.94949 18.451 6.87492 18.5226C7.15445 18.5285 7.48191 18.5286 7.875 18.5286H14.8879C15.4778 18.5286 15.8951 18.5284 16.2229 18.5054C16.5461 18.4827 16.7455 18.4396 16.9036 18.3719C17.0943 18.2904 17.2689 18.1797 17.422 18.0452C17.4998 17.9769 17.572 17.9024 17.638 17.8225ZM8.44213 7.75318C7.8157 7.75318 7.30787 8.26101 7.30787 8.88744C7.30787 9.51388 7.8157 10.0217 8.44213 10.0217C9.06856 10.0217 9.57639 9.51388 9.57639 8.88744C9.57639 8.26101 9.06856 7.75318 8.44213 7.75318ZM6.33565 8.88744C6.33565 7.72406 7.27875 6.78096 8.44213 6.78096C9.60551 6.78096 10.5486 7.72406 10.5486 8.88744C10.5486 10.0508 9.60551 10.9939 8.44213 10.9939C7.27875 10.9939 6.33565 10.0508 6.33565 8.88744Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.8847 3.94488C15.3991 3.94488 14.1949 5.14915 14.1949 6.63469C14.1949 8.12024 15.3991 9.32451 16.8847 9.32451C18.3702 9.32451 19.5745 8.12024 19.5745 6.63469C19.5745 5.14915 18.3702 3.94488 16.8847 3.94488ZM13.2227 6.63469C13.2227 4.61221 14.8622 2.97266 16.8847 2.97266C18.9072 2.97266 20.5467 4.61221 20.5467 6.63469C20.5467 7.47068 20.2666 8.24124 19.7951 8.85763L20.8581 9.92059C21.0479 10.1104 21.0479 10.4182 20.8581 10.6081C20.6682 10.7979 20.3604 10.7979 20.1706 10.6081L19.1076 9.5451C18.4912 10.0166 17.7207 10.2967 16.8847 10.2967C14.8622 10.2967 13.2227 8.65718 13.2227 6.63469Z'
    />
  </svg>
);

const CelebraPlace = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M4 12.1053L19 5L11.8947 20L10.3158 13.6842L4 12.1053Z'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraPackDelivery = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      xmlns='http://www.w3.org/2000/svg'
      d='M12.0261 3.23309L11.7779 2.79904L11.7779 2.79905L12.0261 3.23309ZM13.7739 3.23309L14.0221 2.79905L14.0221 2.79904L13.7739 3.23309ZM20.5374 7.10107L20.7858 6.66717L20.7856 6.66704L20.5374 7.10107ZM21 7.911L20.5 7.91098V7.911H21ZM21 15.5423L21.5 15.5424V15.5423H21ZM20.0739 17.1621L19.8257 16.7281L19.8256 16.7281L20.0739 17.1621ZM13.7739 20.7669L14.0221 21.201L14.0222 21.2009L13.7739 20.7669ZM12.0261 20.7669L12.2743 20.3329C12.2658 20.328 12.2572 20.3234 12.2485 20.3191L12.0261 20.7669ZM9.52249 18.9651C9.27517 18.8423 8.9751 18.9432 8.85226 19.1905C8.72942 19.4378 8.83033 19.7379 9.07765 19.8607L9.30007 19.4129L9.52249 18.9651ZM4.49004 7.19321C4.35309 7.43299 4.43644 7.7384 4.67623 7.87536C4.91602 8.01232 5.22143 7.92896 5.35838 7.68917L4.92421 7.44119L4.49004 7.19321ZM5.2626 7.10107L5.01438 6.66704L5.01415 6.66717L5.2626 7.10107ZM9.09827 4.61538C8.85857 4.47827 8.5531 4.56143 8.41599 4.80113C8.27888 5.04082 8.36204 5.34629 8.60173 5.4834L8.85 5.04939L9.09827 4.61538ZM16.95 9.68282H17.45C17.45 9.50347 17.3539 9.33786 17.1983 9.24881L16.95 9.68282ZM16.45 12.9262C16.45 13.2024 16.6739 13.4262 16.95 13.4262C17.2261 13.4262 17.45 13.2024 17.45 12.9262H16.95H16.45ZM6.6 11.5728C6.87614 11.5728 7.1 11.3489 7.1 11.0728C7.1 10.7966 6.87614 10.5728 6.6 10.5728V11.0728V11.5728ZM3 10.5728C2.72386 10.5728 2.5 10.7966 2.5 11.0728C2.5 11.3489 2.72386 11.5728 3 11.5728V11.0728V10.5728ZM8.4 17.1329C8.67614 17.1329 8.9 16.909 8.9 16.6329C8.9 16.3567 8.67614 16.1329 8.4 16.1329L8.4 16.6329V17.1329ZM3 16.1329C2.72386 16.1329 2.5 16.3567 2.5 16.6329C2.5 16.909 2.72386 17.1329 3 17.1329L3 16.6329L3 16.1329ZM10.2 14.3528C10.4761 14.3528 10.7 14.129 10.7 13.8528C10.7 13.5767 10.4761 13.3528 10.2 13.3528V13.8528V14.3528ZM5.7 13.3528C5.42386 13.3528 5.2 13.5767 5.2 13.8528C5.2 14.129 5.42386 14.3528 5.7 14.3528V13.8528V13.3528ZM12.0261 3.23309L12.2743 3.66714C12.4666 3.55716 12.6819 3.5 12.9 3.5V3V2.5C12.5065 2.5 12.1203 2.60327 11.7779 2.79904L12.0261 3.23309ZM12.9 3V3.5C13.1181 3.5 13.3334 3.55716 13.5257 3.66714L13.7739 3.23309L14.0221 2.79904C13.6797 2.60327 13.2935 2.5 12.9 2.5V3ZM13.7739 3.23309L13.5257 3.66712L20.2892 7.53511L20.5374 7.10107L20.7856 6.66704L14.0221 2.79905L13.7739 3.23309ZM20.5374 7.10107L20.289 7.53498C20.3506 7.57027 20.4038 7.62298 20.4416 7.68917L20.8758 7.44119L21.31 7.19321C21.1851 6.9746 21.0047 6.79245 20.7858 6.66717L20.5374 7.10107ZM20.8758 7.44119L20.4416 7.68917C20.4795 7.75546 20.5 7.83209 20.5 7.91098L21 7.911L21.5 7.91102C21.5 7.6595 21.4348 7.41173 21.31 7.19321L20.8758 7.44119ZM21 7.911H20.5V15.5423H21H21.5V7.911H21ZM21 15.5423L20.5 15.5421C20.4999 15.7863 20.4364 16.0252 20.3171 16.2339L20.7512 16.482L21.1853 16.7302C21.3916 16.3693 21.4999 15.9592 21.5 15.5424L21 15.5423ZM20.7512 16.482L20.3171 16.2339C20.1979 16.4425 20.0277 16.6126 19.8257 16.7281L20.0739 17.1621L20.3221 17.5962C20.6813 17.3907 20.9788 17.0912 21.1853 16.7302L20.7512 16.482ZM20.0739 17.1621L19.8256 16.7281L13.5256 20.3329L13.7739 20.7669L14.0222 21.2009L20.3222 17.5961L20.0739 17.1621ZM13.7739 20.7669L13.5257 20.3329C13.3334 20.4428 13.1181 20.5 12.9 20.5V21V21.5C13.2935 21.5 13.6797 21.3967 14.0221 21.201L13.7739 20.7669ZM12.9 21V20.5C12.6819 20.5 12.4666 20.4428 12.2743 20.3329L12.0261 20.7669L11.7779 21.201C12.1203 21.3967 12.5065 21.5 12.9 21.5V21ZM12.0261 20.7669L12.2485 20.3191L9.52249 18.9651L9.30007 19.4129L9.07765 19.8607L11.8037 21.2147L12.0261 20.7669ZM4.92421 7.44119L5.35838 7.68917C5.39619 7.62298 5.44941 7.57027 5.51104 7.53498L5.2626 7.10107L5.01415 6.66717C4.79535 6.79245 4.61491 6.9746 4.49004 7.19321L4.92421 7.44119ZM5.2626 7.10107L5.51082 7.53511L12.2743 3.66712L12.0261 3.23309L11.7779 2.79905L5.01438 6.66704L5.2626 7.10107ZM8.85 5.04939L8.60173 5.4834L16.7017 10.1168L16.95 9.68282L17.1983 9.24881L9.09827 4.61538L8.85 5.04939ZM16.95 9.68282H16.45V12.9262H16.95H17.45V9.68282H16.95ZM4.8 7.36611L4.55173 7.80012L12.6517 12.4335L12.9 11.9995L13.1483 11.5655L5.04827 6.9321L4.8 7.36611ZM12.9 11.9995L13.1483 12.4335L21.2483 7.80012L21 7.36611L20.7517 6.9321L12.6517 11.5655L12.9 11.9995ZM12.9 11.9995H12.4V20.8031H12.9H13.4V11.9995H12.9ZM6.6 11.0728V10.5728H3V11.0728V11.5728H6.6V11.0728ZM8.4 16.6329L8.4 16.1329L3 16.1329L3 16.6329L3 17.1329L8.4 17.1329V16.6329ZM10.2 13.8528V13.3528H5.7V13.8528V14.3528H10.2V13.8528Z'
    />
  </svg>
);

const CelebraPlus = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke'
      d='M12 4V20M4 12H20'
      stroke='#4D4D4D'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraScroll = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 16 38'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M10 3L8 1L6 3'
      stroke='#4D4D4D'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <rect
      className='_stroke icon__nofill'
      x='0.5'
      y='7.5'
      width='15'
      height='23'
      rx='7.5'
      stroke='#4D4D4D'
    />
    <path
      className='_stroke icon__nofill'
      d='M8 12L8 16'
      stroke='#4D4D4D'
      strokeLinecap='round'
    />
    <path
      className='_stroke icon__nofill'
      d='M6 35L8 37L10 35'
      stroke='#4D4D4D'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraSearch = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 25 25'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.8784 2.5C6.25113 2.5 2.5 6.25113 2.5 10.8784C2.5 15.5056 6.25113 19.2568 10.8784 19.2568C12.9 19.2568 14.7544 18.5407 16.2018 17.3485L21.1159 22.2625C21.4325 22.5792 21.9459 22.5792 22.2625 22.2625C22.5792 21.9459 22.5792 21.4325 22.2625 21.1159L17.3485 16.2018C18.5407 14.7544 19.2568 12.9 19.2568 10.8784C19.2568 6.25113 15.5056 2.5 10.8784 2.5ZM4.12162 10.8784C4.12162 7.14672 7.14672 4.12162 10.8784 4.12162C14.61 4.12162 17.6351 7.14672 17.6351 10.8784C17.6351 14.61 14.61 17.6351 10.8784 17.6351C7.14672 17.6351 4.12162 14.61 4.12162 10.8784Z'
    />
  </svg>
);

const CelebraShareLink = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M5 11.333V17.733C5 18.1574 5.17151 18.5643 5.4768 18.8644C5.78209 19.1644 6.19616 19.333 6.62791 19.333H17.3721C17.8038 19.333 18.2179 19.1644 18.5232 18.8644C18.8285 18.5643 19 18.1574 19 17.733V11.333M15 8.33333L12 5M12 5L9 8.33333M12 5V15.8333'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraPrint = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className={`_stroke`}
      d='M8.87891 1.7627H15.04C16.018 1.76289 16.8184 2.56398 16.8184 3.54199V5.50293H18.9502C20.5322 5.50293 21.8242 6.82028 21.8242 8.41016V14.0205C21.824 15.6103 20.5374 16.9268 18.9502 16.9268H17.9189V20.043C17.9189 21.0211 17.1178 21.8213 16.1396 21.8213H7.7793C6.80117 21.8213 6.00001 21.0211 6 20.043V16.9268H4.96875C3.38691 16.9268 2.09495 15.6102 2.09473 14.0205V8.41016C2.09473 6.82028 3.38678 5.50293 4.96875 5.50293H7.10059V3.54199C7.10059 2.56399 7.90096 1.76292 8.87891 1.7627ZM7.3584 20.043C7.3584 20.2749 7.54736 20.4639 7.7793 20.4639H16.1396C16.3716 20.4639 16.5615 20.2749 16.5615 20.043V13.1309H7.3584V20.043ZM4.96875 6.86133C4.12909 6.86133 3.45312 7.57592 3.45312 8.41016V14.0205C3.45334 14.8603 4.12944 15.5693 4.96875 15.5693H6V12.4307C6 12.0611 6.30234 11.7737 6.67871 11.7734H17.2402C17.6166 11.7737 17.9189 12.0611 17.9189 12.4307V15.5693H18.9502C19.7897 15.5693 20.4656 14.8546 20.4658 14.0205V13.9287H20.4609V8.41016C20.4609 7.57032 19.7846 6.86156 18.9453 6.86133H4.96875ZM8.87891 3.12109C8.64715 3.12131 8.45801 3.31019 8.45801 3.54199V5.50293H15.4609V3.54199C15.4609 3.31018 15.2718 3.12129 15.04 3.12109H8.87891Z'
      stroke='white'
      strokeWidth='0.182609'
    />
    <path
      className={`_stroke`}
      d='M7.02539 8.47363V9.83203H5.99707V8.47363H7.02539Z'
      stroke='white'
      strokeWidth='0.182609'
    />
  </svg>
);

const CelebraSquare = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect
      className='_stroke icon__nofill'
      x='4'
      y='4'
      width='16'
      height='16'
      rx='2'
      stroke='#181818'
    />
  </svg>
);

const CelebraSquareCheckFilled = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect
      className='_stroke icon__fill'
      x='4'
      y='4'
      width='16'
      height='16'
      rx='2'
      stroke='#181818'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.9484 7.64097C18.1467 7.83315 18.1516 8.1497 17.9594 8.34799L10.2056 16.348C10.1114 16.4452 9.98186 16.5 9.84654 16.5C9.71123 16.5 9.58169 16.4452 9.48751 16.348L6.04136 12.7924C5.84917 12.5941 5.85412 12.2776 6.0524 12.0854C6.25069 11.8932 6.56724 11.8982 6.75942 12.0965L9.84654 15.2816L17.2414 7.65201C17.4335 7.45372 17.7501 7.44878 17.9484 7.64097Z'
      fill='white'
    />
  </svg>
);

const CelebraStar = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.0325 3.60338C11.4402 2.79887 12.5598 2.79887 12.9675 3.60338L15.2186 8.04631C15.2468 8.10198 15.2993 8.14129 15.3607 8.1526L20.1006 9.02635C20.955 9.18384 21.2969 10.2542 20.6998 10.9018L17.3376 14.5481C17.2973 14.5918 17.2785 14.6513 17.2865 14.7103L17.9607 19.7227C18.0808 20.6157 17.179 21.2821 16.394 20.8803L12 18.6312L7.60602 20.8803C6.82105 21.2821 5.91916 20.6157 6.03928 19.7227L6.71355 14.7103C6.72149 14.6513 6.70272 14.5918 6.66237 14.5481L3.30023 10.9018C2.7031 10.2542 3.04505 9.18384 3.89937 9.02635L8.6393 8.1526C8.70067 8.14129 8.75324 8.10198 8.78145 8.04631L11.0325 3.60338ZM14.2959 8.65277L12 4.1215L9.70414 8.65277C9.54803 8.96089 9.26182 9.17724 8.9292 9.23855L4.44843 10.0645C4.29359 10.0931 4.23092 10.281 4.33765 10.3968L7.51773 13.8456C7.74574 14.0929 7.85204 14.4333 7.80664 14.7708L7.17081 19.4975C7.14929 19.6575 7.31644 19.7757 7.46016 19.7022L11.5138 17.6272C11.82 17.4705 12.18 17.4705 12.4862 17.6272L16.5398 19.7022C16.6836 19.7757 16.8507 19.6575 16.8292 19.4975L16.1934 14.7708C16.148 14.4333 16.2543 14.0929 16.4823 13.8456L19.6623 10.3968C19.7691 10.281 19.7064 10.0931 19.5516 10.0645L15.0708 9.23855C14.7382 9.17723 14.452 8.96089 14.2959 8.65277Z'
    />
  </svg>
);

const CelebraStarCicle = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M7.2 7.2L8.8 5.6M8.8 5.6L7.2 4M8.8 5.6H7.2C5.43269 5.6 4 7.03269 4 8.8M16.8 16.8L15.2 18.4M15.2 18.4L16.8 20M15.2 18.4H16.8C18.5673 18.4 20 16.9673 20 15.2M12.8441 9.48918L10.4043 7.18835C10.1472 6.94584 10.0186 6.82459 10.003 6.70988C9.98936 6.61008 10.023 6.50966 10.0945 6.43658C10.1767 6.35258 10.3543 6.32745 10.7095 6.27718L14.0825 5.79984C14.1874 5.78499 14.2398 5.77757 14.2855 5.75701C14.3259 5.7388 14.3623 5.71316 14.3927 5.68153C14.427 5.6458 14.4505 5.59978 14.4974 5.50774L16.0053 2.54995C16.1642 2.23821 16.2437 2.0823 16.3516 2.0325C16.4455 1.98917 16.5545 1.98917 16.6484 2.0325C16.7563 2.0823 16.8358 2.23819 16.9947 2.54995L18.5026 5.50774C18.5495 5.59978 18.573 5.6458 18.6073 5.68153C18.6377 5.71316 18.6741 5.7388 18.7145 5.75701C18.7602 5.77757 18.8126 5.785 18.9175 5.79984L22.2905 6.27718C22.6457 6.32745 22.8233 6.35258 22.9055 6.43658C22.977 6.50966 23.0106 6.61008 22.997 6.70988C22.9814 6.82459 22.8528 6.94584 22.5957 7.18835L20.1558 9.48918C20.0798 9.56091 20.0418 9.59677 20.0172 9.63944C19.9955 9.67722 19.9816 9.71873 19.9762 9.76166C19.9701 9.81014 19.9791 9.8608 19.997 9.96211L20.5727 13.2119C20.6334 13.5547 20.6638 13.7261 20.6067 13.8278C20.5571 13.9163 20.4689 13.9784 20.3666 13.9967C20.2491 14.0178 20.0901 13.9369 19.7722 13.775L16.7568 12.2396C16.6628 12.1918 16.6158 12.1679 16.5664 12.1585C16.5225 12.1501 16.4775 12.1501 16.4336 12.1585C16.3842 12.1679 16.3372 12.1918 16.2432 12.2396L15.5 12.5M13.6 15.2C13.6 17.851 11.451 20 8.8 20C6.14903 20 4 17.851 4 15.2C4 12.549 6.14903 10.4 8.8 10.4C11.451 10.4 13.6 12.549 13.6 15.2Z'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraStarCircle = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M9.9544 9.66653L9.88538 9.17132L9.9544 9.66653ZM10.1262 9.63084L9.92351 9.17376L10.1262 9.63084ZM10.3055 9.42311L9.86144 9.19326L10.3055 9.42311ZM10.2169 9.56794L10.575 9.91687L10.2169 9.56794ZM6.84213 10.8236L7.18239 10.4573L6.84213 10.8236ZM6.50251 10.4249L6.99779 10.3563L6.50251 10.4249ZM7.10032 10.0643L7.16934 10.5595L7.10032 10.0643ZM6.57996 10.1971L6.22526 9.84474L6.57996 10.1971ZM9.04097 13.1351L9.53307 13.2236L9.04097 13.1351ZM9.05861 12.968L9.55462 12.905L9.05861 12.968ZM8.90659 12.741L8.56633 13.1073L8.90659 12.741ZM9.02389 12.8662L8.59211 13.1183L9.02389 12.8662ZM9.23121 16.3125L9.45534 16.7594L9.23121 16.3125ZM8.72826 16.4973L8.64123 16.9896L8.72826 16.4973ZM8.55385 15.8433L8.06175 15.7548L8.55385 15.8433ZM8.52506 16.3565L8.95952 16.109H8.95952L8.52506 16.3565ZM12.2173 15.033L12.4414 14.5861L12.2173 15.033ZM12.0561 14.9654L12.1481 14.4739L12.0561 14.9654ZM11.7827 15.033L11.5586 14.5861L11.7827 15.033ZM11.9439 14.9654L12.0358 15.4569L11.9439 14.9654ZM15.4461 15.8433L14.954 15.9318L15.4461 15.8433ZM15.4749 16.3565L15.9094 16.604L15.4749 16.3565ZM14.7688 16.3125L14.5447 16.7594L14.7688 16.3125ZM15.2717 16.4973L15.1847 16.0049L15.2717 16.4973ZM15.0934 12.741L14.7531 12.3746V12.3746L15.0934 12.741ZM14.9761 12.8662L15.4079 13.1183L14.9761 12.8662ZM14.959 13.1351L15.4511 13.0466L14.959 13.1351ZM14.9414 12.968L14.4454 12.905L14.9414 12.968ZM16.8997 10.0643L16.8307 10.5595L16.8997 10.0643ZM17.42 10.1971L17.7747 9.84474L17.42 10.1971ZM17.1579 10.8236L17.4981 11.19V11.19L17.1579 10.8236ZM17.4975 10.4249L17.0022 10.3563L17.4975 10.4249ZM13.6945 9.42311L13.2505 9.65297L13.2505 9.65297L13.6945 9.42311ZM13.7831 9.56794L13.425 9.91687L13.7831 9.56794ZM14.0456 9.66653L13.9766 10.1617L14.0456 9.66653ZM13.8738 9.63084L14.0765 9.17376L13.8738 9.63084ZM12.4186 6.95829L12.8626 6.72843V6.72843L12.4186 6.95829ZM12.1256 6.52708L12.3325 6.07192L12.1256 6.52708ZM11.5814 6.95829L12.0254 7.18815L11.5814 6.95829ZM11.8744 6.52708L11.6675 6.07192L11.8744 6.52708ZM12.4186 6.95829L11.9746 7.18815L13.2505 9.65297L13.6945 9.42311L14.1386 9.19326L12.8626 6.72843L12.4186 6.95829ZM14.0456 9.66653L13.9766 10.1617L16.8307 10.5595L16.8997 10.0643L16.9687 9.56911L14.1146 9.17132L14.0456 9.66653ZM17.1579 10.8236L16.8176 10.4573L14.7531 12.3746L15.0934 12.741L15.4337 13.1074L17.4981 11.19L17.1579 10.8236ZM14.959 13.1351L14.4669 13.2236L14.954 15.9318L15.4461 15.8433L15.9382 15.7548L15.4511 13.0466L14.959 13.1351ZM14.7688 16.3125L14.9929 15.8655L12.4414 14.5861L12.2173 15.033L11.9931 15.48L14.5447 16.7594L14.7688 16.3125ZM11.7827 15.033L11.5586 14.5861L9.00709 15.8655L9.23121 16.3125L9.45534 16.7594L12.0069 15.48L11.7827 15.033ZM8.55385 15.8433L9.04596 15.9318L9.53307 13.2236L9.04097 13.1351L8.54887 13.0466L8.06175 15.7548L8.55385 15.8433ZM8.90659 12.741L9.24685 12.3746L7.18239 10.4573L6.84213 10.8236L6.50187 11.19L8.56633 13.1073L8.90659 12.741ZM7.10032 10.0643L7.16934 10.5595L10.0234 10.1617L9.9544 9.66653L9.88538 9.17132L7.0313 9.56911L7.10032 10.0643ZM10.3055 9.42311L10.7495 9.65297L12.0254 7.18815L11.5814 6.95829L11.1374 6.72843L9.86144 9.19326L10.3055 9.42311ZM9.9544 9.66653L10.0234 10.1617C10.0829 10.1535 10.2109 10.1402 10.3289 10.0879L10.1262 9.63084L9.92351 9.17376C9.95097 9.16158 9.97008 9.15842 9.96399 9.1596C9.96038 9.1603 9.95313 9.16157 9.93907 9.16368C9.92493 9.1658 9.90831 9.16812 9.88538 9.17132L9.9544 9.66653ZM10.3055 9.42311L9.86144 9.19326C9.85115 9.21314 9.84385 9.22722 9.83754 9.23909C9.83128 9.25085 9.82818 9.2563 9.82691 9.25844C9.82581 9.2603 9.82822 9.25604 9.83367 9.24857C9.8396 9.24046 9.84799 9.2301 9.85879 9.21901L10.2169 9.56794L10.575 9.91687C10.6679 9.82151 10.7238 9.70269 10.7495 9.65297L10.3055 9.42311ZM10.1262 9.63084L10.3289 10.0879C10.4203 10.0474 10.5041 9.98964 10.575 9.91687L10.2169 9.56794L9.85879 9.21901C9.87832 9.19896 9.90052 9.18396 9.92351 9.17376L10.1262 9.63084ZM6.84213 10.8236L7.18239 10.4573C7.12708 10.4059 7.08285 10.3648 7.04549 10.3289C7.00786 10.2928 6.9837 10.2681 6.96785 10.2504C6.95125 10.2319 6.953 10.2312 6.96064 10.2441C6.96947 10.259 6.9897 10.2979 6.99779 10.3563L6.50251 10.4249L6.00724 10.4935C6.03557 10.6981 6.15549 10.8424 6.22354 10.9182C6.29849 11.0018 6.40044 11.0958 6.50187 11.19L6.84213 10.8236ZM7.10032 10.0643L7.0313 9.56911C6.8905 9.58873 6.75193 9.60758 6.64177 9.63284C6.54112 9.65592 6.36563 9.70347 6.22526 9.84474L6.57996 10.1971L6.93465 10.5496C6.89634 10.5881 6.86081 10.6056 6.84827 10.611C6.83755 10.6157 6.83929 10.6135 6.86526 10.6075C6.89024 10.6018 6.92596 10.5952 6.97896 10.5869C7.03162 10.5787 7.09302 10.5702 7.16934 10.5595L7.10032 10.0643ZM6.50251 10.4249L6.99779 10.3563C7.00823 10.4318 6.98124 10.5027 6.93465 10.5496L6.57996 10.1971L6.22526 9.84474C6.05766 10.0134 5.97376 10.2517 6.00724 10.4935L6.50251 10.4249ZM9.04097 13.1351L9.53307 13.2236C9.54256 13.1708 9.57171 13.0394 9.55462 12.905L9.05861 12.968L8.56261 13.0311C8.56048 13.0144 8.56004 12.9999 8.56027 12.989C8.56047 12.9789 8.56122 12.9734 8.56101 12.9752C8.56076 12.9773 8.55995 12.9832 8.55777 12.9962C8.55673 13.0024 8.55549 13.0095 8.55397 13.0181C8.55245 13.0266 8.55079 13.0359 8.54887 13.0466L9.04097 13.1351ZM8.90659 12.741L8.56633 13.1073C8.58299 13.1228 8.5949 13.1339 8.60491 13.1434C8.61486 13.1528 8.61957 13.1576 8.62156 13.1596C8.62336 13.1615 8.62006 13.1582 8.61439 13.1511C8.60822 13.1433 8.60025 13.1323 8.59211 13.1183L9.02389 12.8662L9.45567 12.6141C9.38872 12.4994 9.28805 12.4129 9.24685 12.3746L8.90659 12.741ZM9.05861 12.968L9.55462 12.905C9.54149 12.8018 9.50757 12.703 9.45567 12.6141L9.02389 12.8662L8.59211 13.1183C8.57697 13.0924 8.56663 13.0628 8.56261 13.0311L9.05861 12.968ZM9.23121 16.3125L9.00709 15.8655C8.93875 15.8998 8.88388 15.9273 8.83633 15.9502C8.78848 15.9732 8.75572 15.9878 8.73221 15.9971C8.70789 16.0067 8.70503 16.006 8.716 16.0039C8.72908 16.0013 8.76556 15.9961 8.81529 16.0049L8.72826 16.4973L8.64123 16.9896C8.83375 17.0237 9.00168 16.9659 9.1001 16.927C9.20522 16.8854 9.32944 16.8226 9.45534 16.7594L9.23121 16.3125ZM8.55385 15.8433L8.06175 15.7548C8.03791 15.8873 8.01306 16.0224 8.0038 16.1339C7.99518 16.2377 7.98813 16.4241 8.09061 16.604L8.52506 16.3565L8.95952 16.109C8.98799 16.159 8.99609 16.2018 8.9984 16.2211C9.00037 16.2375 8.99846 16.2397 9.00037 16.2166C9.0022 16.1946 9.00638 16.1619 9.01447 16.1119C9.02251 16.0623 9.03288 16.0045 9.04596 15.9318L8.55385 15.8433ZM8.72826 16.4973L8.81529 16.0049C8.86925 16.0144 8.92495 16.0483 8.95952 16.109L8.52506 16.3565L8.09061 16.604C8.20918 16.8121 8.41421 16.9495 8.64123 16.9896L8.72826 16.4973ZM12.2173 15.033L12.4414 14.5861C12.3878 14.5592 12.2754 14.4977 12.1481 14.4739L12.0561 14.9654L11.9642 15.4569C11.9504 15.4543 11.9389 15.4511 11.9307 15.4483C11.9232 15.4459 11.9199 15.4443 11.9228 15.4455C11.926 15.4469 11.9325 15.4499 11.9451 15.456C11.9578 15.4622 11.9726 15.4697 11.9931 15.48L12.2173 15.033ZM11.7827 15.033L12.0069 15.48C12.0274 15.4697 12.0422 15.4622 12.0549 15.456C12.0675 15.4499 12.074 15.4469 12.0772 15.4455C12.0801 15.4443 12.0768 15.4459 12.0693 15.4483C12.0611 15.4511 12.0496 15.4543 12.0358 15.4569L11.9439 14.9654L11.8519 14.4739C11.7246 14.4977 11.6122 14.5592 11.5586 14.5861L11.7827 15.033ZM12.0561 14.9654L12.1481 14.4739C12.0502 14.4556 11.9498 14.4556 11.8519 14.4739L11.9439 14.9654L12.0358 15.4569C12.0121 15.4613 11.9879 15.4613 11.9642 15.4569L12.0561 14.9654ZM15.4461 15.8433L14.954 15.9318C14.9671 16.0045 14.9775 16.0623 14.9855 16.1119C14.9936 16.1619 14.9978 16.1946 14.9996 16.2166C15.0015 16.2397 14.9996 16.2375 15.0016 16.2211C15.0039 16.2018 15.012 16.159 15.0405 16.109L15.4749 16.3565L15.9094 16.604C16.0119 16.4241 16.0048 16.2377 15.9962 16.1339C15.9869 16.0224 15.9621 15.8873 15.9382 15.7548L15.4461 15.8433ZM14.7688 16.3125L14.5447 16.7594C14.6706 16.8226 14.7948 16.8854 14.8999 16.927C14.9983 16.9659 15.1663 17.0237 15.3588 16.9896L15.2717 16.4973L15.1847 16.0049C15.2344 15.9961 15.2709 16.0013 15.284 16.0039C15.295 16.006 15.2921 16.0067 15.2678 15.9971C15.2443 15.9878 15.2115 15.9732 15.1637 15.9502C15.1161 15.9273 15.0612 15.8998 14.9929 15.8655L14.7688 16.3125ZM15.4749 16.3565L15.0405 16.109C15.075 16.0483 15.1307 16.0144 15.1847 16.0049L15.2717 16.4973L15.3588 16.9896C15.5858 16.9495 15.7908 16.8121 15.9094 16.604L15.4749 16.3565ZM15.0934 12.741L14.7531 12.3746C14.7119 12.4129 14.6113 12.4994 14.5443 12.6141L14.9761 12.8662L15.4079 13.1183C15.3998 13.1323 15.3918 13.1433 15.3856 13.1511C15.3799 13.1582 15.3766 13.1615 15.3784 13.1596C15.3804 13.1576 15.3851 13.1528 15.3951 13.1434C15.4051 13.1339 15.417 13.1228 15.4337 13.1074L15.0934 12.741ZM14.959 13.1351L15.4511 13.0466C15.4492 13.0359 15.4475 13.0266 15.446 13.0181C15.4445 13.0095 15.4433 13.0024 15.4422 12.9962C15.44 12.9832 15.4392 12.9773 15.439 12.9752C15.4388 12.9734 15.4395 12.9789 15.4397 12.989C15.44 12.9999 15.4395 13.0144 15.4374 13.0311L14.9414 12.968L14.4454 12.905C14.4283 13.0394 14.4574 13.1708 14.4669 13.2236L14.959 13.1351ZM14.9761 12.8662L14.5443 12.6141C14.4924 12.703 14.4585 12.8018 14.4454 12.905L14.9414 12.968L15.4374 13.0311C15.4334 13.0628 15.423 13.0924 15.4079 13.1183L14.9761 12.8662ZM16.8997 10.0643L16.8307 10.5595C16.907 10.5702 16.9684 10.5787 17.021 10.5869C17.074 10.5952 17.1098 10.6018 17.1347 10.6075C17.1607 10.6135 17.1625 10.6157 17.1517 10.611C17.1392 10.6056 17.1037 10.5881 17.0653 10.5496L17.42 10.1971L17.7747 9.84474C17.6344 9.70347 17.4589 9.65592 17.3582 9.63284C17.2481 9.60758 17.1095 9.58873 16.9687 9.56911L16.8997 10.0643ZM17.1579 10.8236L17.4981 11.19C17.5996 11.0958 17.7015 11.0018 17.7765 10.9182C17.8445 10.8424 17.9644 10.6981 17.9928 10.4935L17.4975 10.4249L17.0022 10.3563C17.0103 10.2979 17.0305 10.259 17.0394 10.2441C17.047 10.2312 17.0488 10.2319 17.0322 10.2504C17.0163 10.2681 16.9921 10.2928 16.9545 10.3289C16.9172 10.3648 16.8729 10.4059 16.8176 10.4573L17.1579 10.8236ZM17.42 10.1971L17.0653 10.5496C17.0188 10.5027 16.9918 10.4318 17.0022 10.3563L17.4975 10.4249L17.9928 10.4935C18.0262 10.2517 17.9423 10.0134 17.7747 9.84474L17.42 10.1971ZM13.6945 9.42311L13.2505 9.65297C13.2762 9.70269 13.3321 9.82151 13.425 9.91687L13.7831 9.56794L14.1412 9.21901C14.152 9.2301 14.1604 9.24046 14.1663 9.24857C14.1718 9.25604 14.1742 9.26029 14.1731 9.25844C14.1718 9.25629 14.1687 9.25085 14.1625 9.23908C14.1561 9.22722 14.1488 9.21314 14.1386 9.19326L13.6945 9.42311ZM14.0456 9.66653L14.1146 9.17132C14.0917 9.16812 14.0751 9.1658 14.0609 9.16368C14.0469 9.16157 14.0396 9.1603 14.036 9.1596C14.0299 9.15842 14.049 9.16158 14.0765 9.17376L13.8738 9.63084L13.6711 10.0879C13.7891 10.1402 13.9171 10.1535 13.9766 10.1617L14.0456 9.66653ZM13.7831 9.56794L13.425 9.91687C13.4959 9.98965 13.5797 10.0474 13.6711 10.0879L13.8738 9.63084L14.0765 9.17376C14.0995 9.18395 14.1217 9.19896 14.1412 9.21901L13.7831 9.56794ZM12.4186 6.95829L12.8626 6.72843C12.8 6.60756 12.7373 6.48515 12.6766 6.39068C12.6191 6.30111 12.5144 6.15463 12.3325 6.07192L12.1256 6.52708L11.9186 6.98225C11.8711 6.96063 11.8422 6.93415 11.8307 6.92214C11.8209 6.912 11.8222 6.91081 11.8351 6.93097C11.8476 6.95042 11.8646 6.97956 11.8889 7.02464C11.9131 7.06942 11.9403 7.12206 11.9746 7.18815L12.4186 6.95829ZM11.5814 6.95829L12.0254 7.18815C12.0597 7.12206 12.0869 7.06942 12.1111 7.02464C12.1354 6.97956 12.1524 6.95042 12.1649 6.93097C12.1778 6.91081 12.1791 6.912 12.1693 6.92214C12.1578 6.93415 12.1289 6.96063 12.0814 6.98225L11.8744 6.52708L11.6675 6.07192C11.4856 6.15463 11.3809 6.30111 11.3234 6.39068C11.2627 6.48516 11.2 6.60756 11.1374 6.72843L11.5814 6.95829ZM12.1256 6.52708L12.3325 6.07192C12.1216 5.97603 11.8784 5.97603 11.6675 6.07192L11.8744 6.52708L12.0814 6.98225C12.0293 7.00592 11.9707 7.00592 11.9186 6.98225L12.1256 6.52708ZM22 12H21.5C21.5 17.2467 17.2467 21.5 12 21.5V22V22.5C17.799 22.5 22.5 17.799 22.5 12H22ZM12 22V21.5C6.75329 21.5 2.5 17.2467 2.5 12H2H1.5C1.5 17.799 6.20101 22.5 12 22.5V22ZM2 12H2.5C2.5 6.75329 6.75329 2.5 12 2.5V2V1.5C6.20101 1.5 1.5 6.20101 1.5 12H2ZM12 2V2.5C17.2467 2.5 21.5 6.75329 21.5 12H22H22.5C22.5 6.20101 17.799 1.5 12 1.5V2Z' />
  </svg>
);

const CelebraStarFilled = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 23 23'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M10.6997 4.54818C11.0465 3.88238 11.9992 3.88238 12.346 4.54818L14.2573 8.21734C14.2839 8.26834 14.3326 8.30415 14.3892 8.3143L18.4153 9.03617C19.1422 9.1665 19.4331 10.0524 18.925 10.5883L16.0716 13.5983C16.0328 13.6392 16.0147 13.6956 16.0224 13.7514L16.5945 17.8884C16.6967 18.6274 15.9294 19.1789 15.2615 18.8464L11.5229 16.985L7.78426 18.8464C7.11637 19.1789 6.34899 18.6274 6.4512 17.8884L7.02334 13.7514C7.03106 13.6956 7.01297 13.6392 6.97417 13.5983L4.12069 10.5883C3.61262 10.0524 3.90356 9.1665 4.63046 9.03617L8.65653 8.3143C8.71314 8.30415 8.76184 8.26834 8.78841 8.21734L10.6997 4.54818Z' />
  </svg>
);

const CelebraStoreBuildings = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M12.9 11.1111H17.22C18.2281 11.1111 18.7321 11.1111 19.1172 11.3049C19.4559 11.4753 19.7312 11.7473 19.9038 12.0818C20.1 12.4621 20.1 12.9599 20.1 13.9556V20M12.9 20V6.84444C12.9 5.8488 12.9 5.35097 12.7038 4.97068C12.5312 4.63617 12.2559 4.36421 11.9172 4.19377C11.5321 4 11.0281 4 10.02 4H6.78C5.77191 4 5.26786 4 4.88282 4.19377C4.54413 4.36421 4.26876 4.63617 4.09619 4.97068C3.9 5.35097 3.9 5.8488 3.9 6.84444V20M21 20H3M7.05 7.55556H9.75M7.05 11.1111H9.75M7.05 14.6667H9.75'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraTrash = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 23 23'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M14.4361 6.64104V6.0099C14.4361 5.12623 14.4361 4.68439 14.2563 4.34687C14.0981 4.04998 13.8457 3.8086 13.5352 3.65733C13.1823 3.48535 12.7202 3.48535 11.7961 3.48535H10.4761C9.55196 3.48535 9.08991 3.48535 8.73695 3.65733C8.42648 3.8086 8.17406 4.04998 8.01586 4.34687C7.83602 4.68439 7.83602 5.12623 7.83602 6.0099V6.64104M9.48605 10.9801V14.9247M12.7861 10.9801V14.9247M3.71094 6.64104H18.5612M16.9112 6.64104V15.477C16.9112 16.8025 16.9112 17.4652 16.6414 17.9715C16.4041 18.4168 16.0255 18.7789 15.5598 19.0058C15.0304 19.2638 14.3373 19.2638 12.9511 19.2638H9.32105C7.93489 19.2638 7.24181 19.2638 6.71237 19.0058C6.24666 18.7789 5.86803 18.4168 5.63073 17.9715C5.36097 17.4652 5.36097 16.8025 5.36097 15.477V6.64104'
      stroke='#181818'
      strokeWidth='0.928143'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraUser = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M12 13C14.2091 13 16 11.2091 16 9C16 6.79086 14.2091 5 12 5C9.79086 5 8 6.79086 8 9C8 11.2091 9.79086 13 12 13ZM12 13C8.68629 13 6 15.6863 6 19M12 13C15.3137 13 18 15.6863 18 19'
      stroke='#181818'
      strokeLinecap='round'
    />
  </svg>
);

const CelebraUserCircle = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_1977_13393)'>
      <g clipPath='url(#clip1_1977_13393)'>
        <path d='M12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4ZM12 5C15.86 5 19 8.14 19 12C19 13.48 18.54 14.85 17.75 15.98C16.87 14.31 15.28 13.06 13.38 12.65C14.34 12.15 15 11.16 15 10C15 8.34 13.66 7 12 7C10.34 7 9 8.34 9 10C9 11.16 9.66 12.15 10.62 12.65C8.72 13.06 7.13 14.31 6.25 15.99C5.46 14.86 5 13.48 5 12C5 8.14 8.14 5 12 5ZM12 12C10.9 12 10 11.1 10 10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 11.1 13.1 12 12 12ZM12 19C10.02 19 8.23 18.17 6.96 16.84C7.8 14.88 9.74 13.5 12 13.5C14.26 13.5 16.2 14.88 17.04 16.84C15.77 18.17 13.98 19 12 19Z' />
      </g>
    </g>
  </svg>
);

export const CelebraUserStar = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M18 12V16.16C18 17.5041 18 18.1762 17.7384 18.6896C17.5083 19.1412 17.1412 19.5083 16.6896 19.7384C16.1762 20 15.5041 20 14.16 20H5.84C4.49587 20 3.82381 20 3.31042 19.7384C2.85883 19.5083 2.49168 19.1412 2.26158 18.6896C2 18.1762 2 17.5041 2 16.16V7.84C2 6.49587 2 5.82381 2.26158 5.31042C2.49168 4.85883 2.85883 4.49168 3.31042 4.26158C3.82381 4 4.49587 4 5.84 4H10M2.11641 18.3411C2.49172 16.9909 3.73005 16 5.19981 16H10.7998C11.5433 16 11.915 16 12.2241 16.0615C13.4935 16.314 14.4858 17.3063 14.7383 18.5757C14.7998 18.8848 14.7998 19.2566 14.7998 20M11.6 10C11.6 11.7673 10.1673 13.2 8.4 13.2C6.63269 13.2 5.2 11.7673 5.2 10C5.2 8.23269 6.63269 6.8 8.4 6.8C10.1673 6.8 11.6 8.23269 11.6 10ZM16.1404 3.84988L13.5457 4.20789C13.2725 4.24559 13.1359 4.26444 13.0727 4.32743C13.0177 4.38224 12.9918 4.45756 13.0023 4.53241C13.0143 4.61844 13.1132 4.70938 13.311 4.89126L15.1878 6.61689C15.2463 6.67068 15.2756 6.69758 15.2944 6.72958C15.3112 6.75792 15.3219 6.78905 15.326 6.82124C15.3307 6.8576 15.3238 6.8956 15.31 6.97158L14.8671 9.40896C14.8204 9.66604 14.7971 9.79457 14.841 9.87085C14.8792 9.93722 14.947 9.98376 15.0257 9.99753C15.1161 10.0133 15.2384 9.95265 15.4829 9.83125L17.8025 8.67971C17.8747 8.64384 17.9109 8.6259 17.949 8.61885C17.9827 8.61261 18.0173 8.61261 18.051 8.61885C18.0891 8.6259 18.1252 8.64384 18.1975 8.67971L20.5171 9.83125C20.7616 9.95265 20.8839 10.0133 20.9743 9.99753C21.053 9.98376 21.1208 9.93722 21.159 9.87085C21.2029 9.79457 21.1796 9.66604 21.1329 9.40896L20.69 6.97158C20.6762 6.8956 20.6693 6.8576 20.674 6.82124C20.6781 6.78905 20.6888 6.75792 20.7056 6.72958C20.7244 6.69758 20.7537 6.67068 20.8122 6.61689L22.689 4.89126C22.8868 4.70938 22.9857 4.61844 22.9977 4.53241C23.0082 4.45756 22.9823 4.38224 22.9273 4.32743C22.8641 4.26444 22.7275 4.24559 22.4543 4.20789L19.8596 3.84988C19.7789 3.83875 19.7386 3.83318 19.7035 3.81775C19.6724 3.8041 19.6443 3.78487 19.621 3.76115C19.5946 3.73435 19.5766 3.69983 19.5405 3.6308L18.3805 1.41246C18.2583 1.17864 18.1971 1.06173 18.1141 1.02437C18.0419 0.991875 17.9581 0.991875 17.8858 1.02437C17.8029 1.06173 17.7417 1.17864 17.6195 1.41246L16.4595 3.6308C16.4234 3.69983 16.4054 3.73435 16.379 3.76115C16.3557 3.78487 16.3276 3.8041 16.2965 3.81775C16.2614 3.83318 16.2211 3.83875 16.1404 3.84988Z'
      stroke='#181818'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraWeather = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 19 15'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      className='_stroke icon__nofill'
      d='M8.00332 4.86416C9.96437 4.75868 12.0046 5.88816 12.6817 8.47234C13.4369 8.53404 14.1415 8.87678 14.656 9.43278C15.1706 9.98879 15.4576 10.7175 15.4604 11.4749C15.4632 12.2323 15.1814 12.9631 14.671 13.5229C14.1605 14.0826 13.4585 14.4305 12.7037 14.4977H4.24829C0.19867 13.9483 -0.35535 8.05483 4.24829 7.26376C4.60855 6.56967 5.14519 5.98254 5.8043 5.56134C6.46342 5.14014 7.22181 4.8997 8.00332 4.86416Z'
      stroke='black'
      strokeWidth='0.964027'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      className='_stroke icon__nofill'
      d='M10.1578 5.39067C10.3558 4.99192 10.6448 4.64532 11.0014 4.37888C11.3581 4.11243 11.7724 3.93361 12.211 3.85685C12.6495 3.78009 13.1 3.80755 13.5259 3.93701C13.9519 4.06647 14.3414 4.29429 14.6631 4.60209C14.9848 4.90988 15.2295 5.28902 15.3776 5.70887C15.5257 6.12872 15.573 6.57751 15.5156 7.01901C15.4583 7.4605 15.2979 7.88231 15.0474 8.25037C14.7969 8.61844 14.4634 8.92243 14.0738 9.1378M12.7045 2.61113V1M9.85196 3.79323L8.71094 2.65221M15.5571 9.50293L16.6981 10.6394M16.7392 6.6458H18.3503M15.5571 3.79323L16.6981 2.65221'
      stroke='black'
      strokeWidth='0.964027'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CelebraWhatsApp = ({
  context = 'default',
  size = 16,
  ...props
}: SVGProps) => (
  <svg
    width={size}
    height={size}
    className={`icon icon__${context}`}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.6687 6.32503C16.1648 4.82646 14.1647 4.00076 12.0336 4C7.64227 4 4.06838 7.55636 4.06685 11.9278C4.06608 13.3252 4.43318 14.6892 5.13031 15.8913L4 20L8.22327 18.8975C9.3868 19.5294 10.697 19.862 12.0302 19.8624H12.0336C16.4242 19.8624 19.9985 16.3056 20 11.9342C20.0008 9.81564 19.173 7.82399 17.6687 6.32541V6.32503ZM12.0336 18.5235H12.0309C10.8429 18.5231 9.67751 18.2053 8.66067 17.605L8.41885 17.4621L5.91262 18.1163L6.58148 15.6845L6.4241 15.4351C5.76135 14.3859 5.41107 13.1731 5.41183 11.9282C5.41336 8.295 8.38371 5.33891 12.0363 5.33891C13.8049 5.33967 15.4673 6.02585 16.7176 7.27162C17.9678 8.51702 18.6558 10.173 18.655 11.9335C18.6535 15.567 15.6832 18.5231 12.0336 18.5231V18.5235ZM15.6656 13.5883C15.4665 13.4891 14.4879 13.0101 14.3053 12.9439C14.1227 12.8778 13.9902 12.8447 13.8576 13.0431C13.7251 13.2416 13.3435 13.6879 13.2273 13.8198C13.1112 13.9521 12.9951 13.9685 12.796 13.8692C12.5971 13.77 11.9557 13.5609 11.1952 12.8861C10.6035 12.3607 10.2039 11.7122 10.0878 11.5138C9.97164 11.3153 10.0756 11.2081 10.1748 11.1097C10.2642 11.0207 10.3739 10.8782 10.4736 10.7626C10.5733 10.647 10.6061 10.5642 10.6726 10.4322C10.7391 10.2999 10.7058 10.1844 10.6562 10.0851C10.6065 9.98593 10.2085 9.01081 10.0423 8.61433C9.88071 8.2281 9.71649 8.28056 9.59462 8.2741C9.47849 8.26839 9.34596 8.26725 9.21302 8.26725C9.08009 8.26725 8.86462 8.31667 8.68204 8.51512C8.49947 8.71354 7.98529 9.19291 7.98529 10.1676C7.98529 11.1424 8.69849 12.0848 8.79818 12.2171C8.89787 12.3494 10.202 14.3501 12.1986 15.2085C12.6735 15.4127 13.0444 15.5347 13.3335 15.6259C13.8103 15.7769 14.2442 15.7556 14.5872 15.7046C14.9696 15.6476 15.7649 15.2252 15.9307 14.7626C16.0964 14.2999 16.0964 13.903 16.0468 13.8206C15.9972 13.7381 15.8642 13.6883 15.6652 13.589L15.6656 13.5883Z'
    />
  </svg>
);

const iconComponents: Record<string, React.ComponentType<SVGProps>> = {
  AlertError,
  AlertSuccess,
  Bag,
  Billing,
  Calendar,
  CardDetails,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronRightLight,
  ClockInStockProcess,
  CreditCard,
  DownloadLink,
  Edit,
  Error,
  EyePasswordOpen,
  EyePasswordSlash,
  FacetsFilter,
  Gift,
  Heart,
  HeartDot,
  HeartFilled,
  Home,
  ImageSearch,
  Info,
  Information,
  Interests,
  Location,
  NoOrders,
  NumberSign,
  PackBeingProcessed,
  Plus,
  Profile,
  ProfileNotification,
  ReturnProductInStore,
  ReturnProductOnline,
  RingHeart,
  ShipmentCancelledStage,
  ShipmentCheckedStage,
  ShipmentDelivered,
  ShipmentSendPackage,
  ShipmentUnreachedStage,
  Shipping,
  SuccessFilled,
  Success,
  Trash,
  Warning,
  CelebraArrowRight,
  CelebraBag,
  CelebraBagStar,
  CelebraBenefits,
  CelebraCalendar,
  CelebraCamera,
  CelebraCard,
  CelebraCardBlank,
  CelebraCardCheck,
  CelebraCardPlus,
  CelebraCardUpload,
  CelebraCategories,
  CelebraChat,
  CelebraChevronDownThick,
  CelebraChevronDownThin,
  CelebraChevronLeftThick,
  CelebraChevronRightThin,
  CelebraCheckCircle,
  CelebraCircle,
  CelebraCircleCheckFilled,
  CelebraClock,
  CelebraClockProcess,
  CelebraClockTime,
  CelebraClose,
  CelebraCopy,
  CelebraCurrencyCircle,
  CelebraCurrencyCoin,
  CelebraDownloadLink,
  CelebraEdit,
  CelebraEye,
  CelebraEyeSlash,
  CelebraFileDownload,
  CelebraFileLoading,
  CelebraFilter,
  CelebraGallery,
  CelebraGift,
  CelebraGiftPlus,
  CelebraHome,
  CelebraInformation,
  CelebraLocation,
  CelebraLockClosed,
  CelebraLockOpen,
  CelebraMail,
  CelebraMapPin,
  CelebraMessage,
  CelebraMinus,
  CelebraPictureSearch,
  CelebraPlace,
  CelebraPackDelivery,
  CelebraPlus,
  CelebraPrint,
  CelebraScroll,
  CelebraSearch,
  CelebraShareLink,
  CelebraSquare,
  CelebraSquareCheckFilled,
  CelebraStar,
  CelebraStarCicle,
  CelebraStarCircle,
  CelebraStarFilled,
  CelebraStoreBuildings,
  CelebraTrash,
  CelebraUser,
  CelebraUserCircle,
  CelebraUserStar,
  CelebraWeather,
  CelebraWhatsApp,
};

export interface IconProps {
  /**
   * Determines which icon should render
   */
  iconName: string;
  /**
   * Determines the properties of the SVG icon rendered
   */
  svgProps?: SVGProps;
  /**
   * Custom optional styles for Icon
   */
  style?: CSSProperties;
}

export const Icon = ({ iconName, svgProps, style }: IconProps) => {
  const IconComponent = iconComponents[iconName] || Bag;
  return <IconComponent {...svgProps} style={style} />;
};
